import _, { isArray } from "lodash";
import { trackFeatureUse } from "./trackFeatureUse";
import moment from "moment";
import {
  COUNT_ABBRS,
  emptyPaginationObj,
  modifiedObj,
  portalOption,
  DUMMY_REGEX_EXP,
  USER_ROLE,
  PARTICIPANT_PROFILE_TABS,
  PARENT_FORM_CATEGORY_SLUG,
  USER_ROLE_TITLE,
  TIMESHEET_PROGRESS_STATUS,
  SHIFT_STATUS,
  PAYROLL_EXPORT_STATUS,
  MIME_TYPES,
  SIL_HOME_PROFILE_TABS,
  WORKER_PROFILE_TABS,
  getParticipantLabel,
  getParticipantImportTemplateFileName,
} from "../Constants/constant";
import GetItemFromLocalstorage from "./GetItemFromLocalstorage";
import { roleAccess } from "helpers/RolesPermission";
import { resolveParticipantFormSubTabByParentSlug } from "../components/ServiceProvider/Participant/ParticipantProfileTabs/participantProfileFormsTab.utils";
import { IMAGE_URL, PARTICIPANT_IMPORT_TEMPLATE_PATH, WORKER_IMPORT_TEMPLATE_PATH, BASE_URL } from "store/services/URL";
import { apiGetRequest } from "helpers/Requests";
import * as FileSaver from "file-saver";
import { PAYROLL_PLATFORMS } from "store/constants";
import store from "../../src/store/index";
import momentTimeZone from "moment-timezone";
import XLSX from "sheetjs-style";
import api from "store/services/sp.services";
import { toast } from "react-toastify";

// export const convertLabelIntoName = (value) => {
//   if (!value) return "";
//   const data = value
//     .replace(/[^a-zA-Z ]/g, "")
//     .toLowerCase()
//     .split(" ")
//     .join("_");
// console.log(data,"data",data && data.length > 0 && data.charAt(data.length - 1) === "_"
// ? data.slice(0, -1)
// : data)
//   return data && data.length > 0 && data.charAt(data.length - 1) === "_"
//     ? data.slice(0, -1)
//     : data;
// };
export const convertLabelIntoName = (value) => {
  if (!value) return "";

  const trimmedValue = value.trim();

  const data = trimmedValue
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .join("_");

  return data;
};

export const resolveDynamicFieldKey = (field, index = 0) => {
  const fromLabel = convertLabelIntoName(field?.lable);
  if (fromLabel) return fromLabel;
  if (field?.name) return field.name;
  return `field_${index}`;
};

export const isDrawnSignaturePayload = (value) =>
  !!value &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  typeof value.name === "string" &&
  value.name !== "" &&
  typeof value.image === "string" &&
  value.image !== "";

export const normalizeStoredSignatures = (signatures) => {
  if (!Array.isArray(signatures)) return [];
  return signatures.filter(isDrawnSignaturePayload);
};

export const findStoredFormSignature = (signatures, ...names) => {
  const stored = normalizeStoredSignatures(signatures);
  const keys = names.filter(Boolean);
  return stored.find((signature) => keys.includes(signature.name));
};

export const signatureImageSrc = (image) => {
  if (!image || typeof image !== "string") return "";
  const trimmed = image.trim();
  if (!trimmed) return "";
  if (
    trimmed.startsWith("data:") ||
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("blob:")
  ) {
    return trimmed;
  }
  return baseURLImage(trimmed.replace(/^\/+/, ""));
};

export const collectDrawnSignatures = (formValues) => {
  if (!formValues || typeof formValues !== "object") return [];
  return Object.entries(formValues)
    .filter(([key]) => key !== "template")
    .map(([, value]) => value)
    .filter(isDrawnSignaturePayload)
    .map((signature) => ({ ...signature }));
};

export const mergeFormSignatures = (existingSignatures, drawnSignatures) => {
  const merged = normalizeStoredSignatures(existingSignatures).map((item) => ({
    ...item,
  }));
  normalizeStoredSignatures(drawnSignatures).forEach((signature) => {
    const index = merged.findIndex((item) => item.name === signature.name);
    if (index >= 0) {
      merged[index] = { ...merged[index], ...signature };
    } else {
      merged.push({ ...signature });
    }
  });
  return merged;
};

export const freshSignatureUploads = (signatures) =>
  normalizeStoredSignatures(signatures).filter((signature) =>
    signature.image.startsWith("data:image")
  );

export const currentDateForValidation = () => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  } else {
    month = `${month}`;
  }
  let day = date.getDate();
  let completeDate = `${year}-${month}-${day}`;
  return completeDate;
};

export const convertClientDataToPrint = (array1) => {
  const UpdatedList = array1.map((item) => {
    return {
      Participant: item?.participant,

      Service: item?.delivered_service_number,
      //  'Service Region'
      "Service Date": item?.delivered_date,

      "Total Service Hour": (item?.hours)
        .toString()
        .concat(":", (item?.mints).toString()),

      // 'Total Service KMs'
      Rate: item?.original_rate,

      Total: item?.total_amount,

      Status: item?.invoice_status,
    };
  });
  return UpdatedList;
};

export const convertCosDataToPrint = (array1) => {
  const UpdatedList = array1.map((item) => {
    return {
      "Support Coordination": item?.support_category_name,
      Service: item?.delivered_service_number,
      "Service Date": item?.delivered_date,
      "Total Service Hour": (item?.hours)
        .toString()
        .concat(":", (item?.mints).toString()),
      // 'Total Service KMs'
      Rate: item?.original_rate,
      Total: item?.total_amount,
    };
  });
  return UpdatedList;
};

export const getReportData = (reportData) => {
  if (reportData && reportData.length > 0) {
    const newList = reportData.map((item) => {
      return {
        ID: item.id,
        Participant: item?.participant?.first_name.concat(
          " ",
          item?.participant?.last_name
        ),
        "Support Item Number": item?.price_catalog?.support_item_number,
        "Support item name": item?.price_catalog?.support_item_name,
        "Service subcategory": item?.service_sub_category?.title,
        "DS-number": item?.delivered_service_number,
        Status: item?.status,
        Unit: item?.unit,
        Quantity:
          item?.unit === "H" ? item?.hours + ":" + item?.mints : item?.quantity,
        "Total amount": item?.total_amount,
        "Bill types": item?.bill_types,
        "Created at": item?.created_at,
      };
    });
    return newList;
  }
};

export const getDifference = (array1, array2) => {
  return array1.filter((object1) => {
    return array2.some((object2) => {
      return object1.value === object2.value;
    });
  });
};

export const isValidFile = (file, type) => {
  if (!file?.name) return "";
  const fileName = file.name.toLowerCase();
  const exts = getFileExtensions(type);
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex <= 0) return "";
  const fileExtension = fileName.slice(lastDotIndex + 1);
  if (!exts.includes(fileExtension)) {
    // Check if type contains Excel/CSV extensions
    const typeLower = (type || "").toLowerCase();
    if (typeLower.includes("xlsx") || typeLower.includes("csv") || typeLower.includes("xls")) {
      const allowedExts = getFileExtensions(type).map(ext => ext.toUpperCase()).join(", ");
      return `Only ${allowedExts} files are allowed.`;
    }
    
    const errorMessages = {
      any: "only Pdf/Doc/Excel/Image files are allowed",
      casenote: "only Pdf/Doc/Image files are allowed",
      feedback: "only Pdf/Doc/Image files are allowed",
      resume: "only Pdf/Doc files are allowed",
      image: "only Image files are allowed",
      default: "only Pdf files are allowed",
    };
    return errorMessages[type] || errorMessages.default;
  }

  return "";
};

export const maxFileSize = (file, size) => {
  if (file.size === 0) return `file size 0 byte please upload another one`;
  if (file.size / (1024 * 1024).toFixed(2) > size) {
    return `Maximum file size allowed is ${size}MB.`;
  }
  return "";
};

export const getFileSize = (file) => {
  if (!file) return "";
  return `${(file.size / (1024 * 1024)).toFixed(2)}MB`;
};

/**
 * Regex for valid folder/file names: alphanumeric, hyphen/dash, underscore, and space.
 * Used in HRM, Participant, and MGT Home document modules for user-entered names only.
 * Not applied to required-document type names (e.g. in upload-required-document flow),
 * which come from the backend and may contain apostrophes, parentheses, etc.
 */
export const FOLDER_FILE_NAME_REGEX = /^[a-zA-Z0-9\-_\s]+$/;

/** Matches folder_structures.name column (Laravel string default 255). */
export const FOLDER_NAME_MAX_LENGTH = 255;

/**
 * Regex for file names: alphanumeric, hyphen, underscore, space, and optional single extension (e.g. .pdf).
 * Kept for callers that still need the strict pattern; document uploads no longer use this.
 */
export const FILE_NAME_WITH_EXT_REGEX = /^[a-zA-Z0-9\-_\s]+(\.[a-zA-Z0-9\-_\s]+)?$/;

/**
 * Returns true if the name is valid for folders or document files.
 * Allowed: letters (a-z, A-Z), numbers (0-9), hyphen/dash (-).
 * @param {string} value - Folder or file name to validate
 * @returns {boolean}
 */
export const isValidFolderOrFileName = (value) => {
  if (value == null || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (trimmed.length === 0) return false;
  return FOLDER_FILE_NAME_REGEX.test(trimmed);
};

/**
 * Returns an error message if the name is invalid, otherwise null.
 * Use for folder names and file names (without extension).
 * @param {string} value - Folder or file name to validate
 * @returns {string|null}
 */
export const getFolderFileNameValidationError = (value) => {
  if (value == null || typeof value !== "string") {
    return "Name is required.";
  }
  const trimmed = value.trim();
  if (trimmed.length === 0) return "Name is required.";
  if (trimmed.length > FOLDER_NAME_MAX_LENGTH) {
    return `Name must be at most ${FOLDER_NAME_MAX_LENGTH} characters.`;
  }
  if (!FOLDER_FILE_NAME_REGEX.test(trimmed)) {
    return "Only letters, numbers, hyphens, underscores, and spaces are allowed. No other special characters.";
  }
  return null;
};

export const SERVICE_CATEGORY_NAME_MAX_LENGTH = 50;

/**
 * Validates SP service category (service type) names for Settings → Service Categories.
 * @param {string} value
 * @returns {string|null}
 */
export const getServiceCategoryNameValidationError = (value) => {
  if (value == null || typeof value !== "string") {
    return "Name is required.";
  }
  const trimmed = value.trim();
  if (trimmed.length === 0) return "Name is required.";
  if (trimmed.length > SERVICE_CATEGORY_NAME_MAX_LENGTH) {
    return `Name must be at most ${SERVICE_CATEGORY_NAME_MAX_LENGTH} characters.`;
  }
  if (!FOLDER_FILE_NAME_REGEX.test(trimmed)) {
    return "Only letters, numbers, hyphens, underscores, and spaces are allowed. No other special characters.";
  }
  return null;
};

/**
 * Returns an error message if the file name is invalid, otherwise null.
 * File name is optional (empty is valid). Any characters are allowed so names
 * like "Screenshot (7).png" upload without being blocked.
 * @param {string} value - File name to validate (may include extension)
 * @returns {string|null}
 */
export const getFileNameValidationError = (value) => {
  if (value == null || typeof value !== "string") return null;
  const trimmed = value.trim();
  if (trimmed.length === 0) return null; // File name is optional
  // Block path separators only — they can break S3/storage keys.
  if (/[\\/]/.test(trimmed)) {
    return "File name cannot contain / or \\.";
  }
  return null;
};

/** Map upload API errors (worker / participant / SIL document folders). */
export const mapDocumentUploadErrorMessage = (errorOrMessage) => {
  const raw =
    typeof errorOrMessage === "string"
      ? errorOrMessage
      : errorOrMessage?.response?.data?.message ||
        errorOrMessage?.response?.data?.error ||
        (typeof errorOrMessage?.response?.data === "string"
          ? errorOrMessage.response.data
          : "") ||
        errorOrMessage?.message ||
        "";
  if (/file name already exist/i.test(String(raw))) {
    return "A file with this name already exists.";
  }
  return raw || "Failed to upload document. Please try again.";
};

export const getFileExtensions = (type) => {
  let exts = "";
  // Handle comma-separated file extensions (e.g., "xlsx,csv,xls")
  if (type && type.includes(",")) {
    exts = type.split(",").map(ext => ext.trim());
    return exts;
  }
  // Handle single file extension (e.g., "xlsx", "csv", "xls")
  const validExtensions = ["xlsx", "csv", "xls", "pdf", "doc", "docx", "png", "jpg", "jpeg", "gif", "zip"];
  if (type && validExtensions.includes(type.toLowerCase())) {
    return [type.toLowerCase()];
  }
  if (type === "any") {
    exts = ["png", "jpg", "jpeg", "gif", "pdf", "doc", "docx", "xlsx", "csv", "xls"];
  } else if (type === "resume") {
    exts = ["pdf", "doc", "docx"];
  } else if (type === "casenote") {
    exts = ["pdf", "doc", "docx",  "csv", "xlsx", "xls", "png", "jpg", "jpeg", "gif", "zip"];
  } else if (type === "feedback") {
    exts = ["pdf", "doc", "docx",  "csv", "xlsx", "xls", "png", "jpg", "jpeg", "gif", "zip"];
  }
    else {
    exts = type === "image" ? ["png", "jpg", "jpeg", "gif"] : ["pdf"];
  }
  return exts;
};

export const baseURLImage = (url) => {
  if (!url) return "";
  return `${IMAGE_URL}${url}`;
};

const encodeDocumentPathSegments = (path) => {
  if (!path || path === "/") return path;
  return path
    .split("/")
    .map((segment) => {
      if (segment === "") return segment;
      try {
        return encodeURIComponent(decodeURIComponent(segment));
      } catch {
        return encodeURIComponent(segment);
      }
    })
    .join("/");
};

/**
 * Sanitizes a document/file URL for iframe src, img src, href, and window.open.
 * Encodes each path segment so characters like #, @, $, and spaces in stored
 * file names do not break the request (# would otherwise start a URL fragment
 * and CloudFront/S3 returns Access Denied for the wrong key).
 * Query strings on absolute URLs (e.g. S3 signed URLs) are left unchanged.
 * @param {string} url - Document URL (e.g. from API or after baseURLImage)
 * @returns {string} URL safe for browser fetch/open
 */
export const sanitizeDocumentUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";

  if (/^https?:\/\//i.test(trimmed)) {
    const queryIndex = trimmed.indexOf("?");
    const beforeQuery = queryIndex >= 0 ? trimmed.slice(0, queryIndex) : trimmed;
    const query = queryIndex >= 0 ? trimmed.slice(queryIndex) : "";
    const match = beforeQuery.match(/^(https?:\/\/[^/]+)(\/.*)?$/i);
    if (match) {
      const origin = match[1];
      const pathname = match[2] || "";
      return origin + encodeDocumentPathSegments(pathname) + query;
    }
    return trimmed;
  }

  const queryIndex = trimmed.indexOf("?");
  const pathOnly = queryIndex >= 0 ? trimmed.slice(0, queryIndex) : trimmed;
  const query = queryIndex >= 0 ? trimmed.slice(queryIndex) : "";
  return encodeDocumentPathSegments(pathOnly) + query;
};

export const getNameProfile = (first, last, background = null) => {
  // Never return "" — empty <img src> resolves to the page URL, retriggers onError, and can freeze the tab.
  const firstName = String(first ?? "").trim() || "N";
  const lastName = String(last ?? "").trim() || "A";
  const bg = background || "random";
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(
    firstName
  )}+${encodeURIComponent(lastName)}&background=${encodeURIComponent(
    String(bg)
  )}`;
};

/** One-shot avatar fallback. Clears onerror first so a failed CDN cannot loop. */
export const applyAvatarImageFallback = (
  event,
  first,
  last,
  background = null
) => {
  const img = event?.target;
  if (!img) return;
  img.onerror = null;
  const nextSrc = getNameProfile(first, last, background);
  if (img.getAttribute("src") !== nextSrc) {
    img.src = nextSrc;
  }
};

export const hasBlankSpaces = (str) => {
  if (!str) return false;
  return str.match(/^\s+$/) !== null;
};

export const parseBooleanVal = (val) => {
  if (val === "yes" || val === "true" || val === true) return true;
  // MySQL / uncast API booleans often arrive as 1/"1" (e.g. is_group_shift).
  if (val === 1 || val === "1") return true;
  return false;
};

const isValidDocumentExpiryMoment = (m) =>
  m.isValid() && m.year() >= 1900 && m.year() <= 9999;

export const getDocumentFileExpiryRaw = (file) =>
  file?.expiry_time ?? file?.expire_date ?? null;

/** Same rules as document Folder cards (expiry date before today). */
export const isDocumentFileExpired = (file) => {
  if (!file) return false;
  const expiryRaw = getDocumentFileExpiryRaw(file);
  if (
    (parseBooleanVal(file.is_expire) || parseBooleanVal(file.is_expired)) &&
    expiryRaw
  ) {
    return true;
  }
  if (!expiryRaw) {
    return (
      parseBooleanVal(file.is_expire) || parseBooleanVal(file.is_expired)
    );
  }
  const expiry = moment(expiryRaw);
  return isValidDocumentExpiryMoment(expiry) && expiry.isBefore(moment(), "day");
};

export const isDocumentFileExpiringSoon = (file, withinDays = 7) => {
  const expiryRaw = getDocumentFileExpiryRaw(file);
  if (!expiryRaw || isDocumentFileExpired(file)) return false;
  const expiry = moment(expiryRaw);
  if (!isValidDocumentExpiryMoment(expiry)) return false;
  return (
    expiry.isSameOrAfter(moment(), "day") &&
    expiry.isBefore(moment().add(withinDays, "days"), "day")
  );
};

/**
 * Normalizes GET sp/policy-categories (and similar) regardless of axios nesting or legacy shapes.
 */
export const normalizePolicyCategoriesIndexPayload = (res) => {
  const inner =
    res?.data?.data !== undefined && res?.data?.data !== null
      ? res.data.data
      : res?.data;
  if (!inner || typeof inner !== "object" || Array.isArray(inner)) {
    if (Array.isArray(inner)) {
      const total = inner.length;
      return {
        rows: inner,
        paginationBlock: {
          data: inner,
          total,
          per_page: total || 1,
          current_page: 1,
          last_page: 1,
          total_pages: 1,
          totalPages: 1,
        },
        queryParams: null,
      };
    }
    return { rows: [], paginationBlock: null, queryParams: null };
  }
  const queryParams = inner.query_params ?? null;
  const pc = inner.policy_categories;
  if (Array.isArray(pc)) {
    const total = pc.length;
    return {
      rows: pc,
      paginationBlock: {
        data: pc,
        total,
        per_page: total || 1,
        current_page: 1,
        last_page: 1,
        total_pages: 1,
        totalPages: 1,
      },
      queryParams,
    };
  }
  if (pc && typeof pc === "object") {
    const meta =
      pc.meta && typeof pc.meta === "object" && !Array.isArray(pc.meta)
        ? pc.meta
        : null;
    const merged = meta ? { ...meta, ...pc } : { ...pc };
    const rows = Array.isArray(merged.data) ? merged.data : [];
    return { rows, paginationBlock: merged, queryParams };
  }
  return { rows: [], paginationBlock: null, queryParams };
};

export const getPaginationObj = (data, query = null) => {
  if (!data && !query) return emptyPaginationObj;
  let normalized = data;
  if (
    data &&
    typeof data === "object" &&
    data.meta &&
    typeof data.meta === "object" &&
    !Array.isArray(data.meta)
  ) {
    normalized = { ...data.meta, ...data };
  }
  const perPage = Number(normalized?.per_page) || 1;
  const totalCount = Number(normalized?.total);
  const inferredTotalPages =
    perPage > 0 && !Number.isNaN(totalCount)
      ? Math.max(1, Math.ceil(totalCount / perPage))
      : undefined;
  let totalPages =
    normalized.total_pages ??
    normalized.totalPages ??
    normalized.last_page ??
    normalized?.meta?.last_page ??
    inferredTotalPages;
  if (totalPages == null || Number.isNaN(Number(totalPages))) {
    totalPages = inferredTotalPages ?? 1;
  }
  const pageRaw =
    normalized.current_page ??
    normalized.page ??
    query?.page ??
    1;
  const obj = {
    page: Number(pageRaw) || 1,
    totalPages: Number(totalPages),
    total: normalized.total,
  };
  if (query) {
    const searchRaw = query.search;
    Object.assign(obj, {
      sort_field: query.sort_field ?? null,
      sort_order: query.sort_order ?? null,
      filter: query.filter ?? null,
      status: query.status ?? null,
      search:
        searchRaw == null || searchRaw === "" ? null : searchRaw,
    });
  }
  return obj;
};

export const selectedTabState = {
  save: (path) => sessionStorage.setItem("currentTab", path),
  get: () =>
    sessionStorage.getItem("currentTab")
      ? JSON.parse(sessionStorage.getItem("currentTab"))
      : null,
};

export const SilHomeselectedTabState = {
  save: (path) => sessionStorage.setItem("silCurrentTab", JSON.stringify(path)),
  get: () =>
    sessionStorage.getItem("silCurrentTab")
      ? JSON.parse(sessionStorage.getItem("silCurrentTab"))
      : null,
  remove: () => sessionStorage.removeItem("silCurrentTab"),
};

export function sleep(ms = 650) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getAge(dateString) {
  if (!dateString || dateString === undefined) return "";
  const date = moment(dateString, "YYYY-MM-DD");
  const years = moment().diff(date, "years");
  const days = moment().diff(date.add(years, "years"), "days", false);
  return { years, days };
}

export const futureDateValidation = (
  date,
  addDaysOrMonth,
  momentAdd,
  fromDate = null,
  isRegex = false
) => {
  const currentDate = fromDate ? fromDate : moment();
  if (isRegex === false && moment(date).isBefore()) return true;
  const afterDate = moment(currentDate).add(addDaysOrMonth, momentAdd);
  const diff = afterDate.diff(date, "days");
  return diff <= 0 ? false : isRegex === true ? DUMMY_REGEX_EXP : true;
};

export const getExtension = (filename) => {
  if (!filename) return;
  const fileNameLength = filename.split("/");
  return filename
    ? filename.split("/")[fileNameLength.length - 1]
    : "sample.pdf";
};

export const getExtensionName = (fileName) => {
  const lastDotIndex = fileName?.lastIndexOf(".");
  return lastDotIndex > 0
    ? `View ${fileName.slice(lastDotIndex + 1).toUpperCase()}`
    : "No File";
};

export const getFileExtension = (fileName) => {
  if (!fileName) return null;
  const lastDotIndex = fileName.lastIndexOf(".");
  return lastDotIndex > 0 ? fileName.slice(lastDotIndex + 1) : null;
};

export const getDynamicFormSelectValue = (editData, key) => {
  return editData
    ? portalOption.find(
        (x) => x.value === (editData[key] === true ? "yes" : "no")
      )
    : key === "required"
    ? portalOption[0]
    : portalOption[1];
};

export const dynamicFormDateValidation = (
  field,
  watchFormData,
  templateIndex,
  inputFieldIndex,
  subInputFieldIndex = null,
  isRegex = true
) => {
  let dates = null;
  const currentDate = moment(new Date());
  let fieldValueDate = null;
  if (field && field.hasOwnProperty("dateValidation")) {
    dates = field.dateValidation.map((x) => x.value);
  } else {
    return false;
  }
  if (Object.keys(watchFormData).length === 0) {
    return false;
  }
  if (
    dates &&
    dates.length > 0 &&
    watchFormData &&
    templateIndex >= 0 &&
    inputFieldIndex >= 0 &&
    watchFormData?.template &&
    watchFormData?.template?.[templateIndex] !== undefined &&
    watchFormData?.template?.[templateIndex]
  ) {
    if (
      subInputFieldIndex === null &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex] !==
        undefined &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex] &&
      `${convertLabelIntoName(field.lable)}` in
        watchFormData.template[templateIndex].input_fields[inputFieldIndex]
    ) {
      fieldValueDate = moment(
        watchFormData.template[templateIndex].input_fields[inputFieldIndex][
          convertLabelIntoName(field.lable)
        ]
      );
    } else if (
      subInputFieldIndex !== null &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex] &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex]
        .sub_section &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex]
        .sub_section[subInputFieldIndex] !== undefined &&
      watchFormData.template[templateIndex].input_fields[inputFieldIndex]
        .sub_section[subInputFieldIndex] &&
      `${convertLabelIntoName(field.lable)}` in
        watchFormData.template[templateIndex].input_fields[inputFieldIndex]
          .sub_section[subInputFieldIndex]
    ) {
      fieldValueDate = moment(
        watchFormData.template[templateIndex].input_fields[inputFieldIndex]
          .sub_section[subInputFieldIndex][convertLabelIntoName(field.lable)]
      );
    }
    const response = validateCurrentDate(
      fieldValueDate,
      currentDate,
      dates,
      isRegex
    );
    return response;
  }
  return DUMMY_REGEX_EXP;
};

export const getUrlRole = () => {
  const user = GetItemFromLocalstorage("user");
  if (user && roleAccess([USER_ROLE.Sp_Standard_User])) {
    return "hrm";
  } else if (user && roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])) {
    return "sp";
  }
  return null;
};

export const textTruncate = (
  str,
  isGreaterThanRequiredCharacters,
  returnCharactersNeeded
) => {
  if (!str) return "";
  return str.length > isGreaterThanRequiredCharacters
    ? str.substring(0, returnCharactersNeeded) + "..."
    : str;
};

/** Strip editor HTML (e.g. `<p>2</p>`) to readable plain text for table previews. */
export const stripHtmlToPlainText = (html) => {
  if (html == null) return "";
  const raw = String(html).trim();
  if (raw === "" || raw.toLowerCase() === "null") return "";
  const text = raw
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/\s+/g, " ")
    .trim();
  return text.toLowerCase() === "null" ? "" : text;
};

/** Drop blank editor paragraphs so empty content does not leave a tall gap. */
export const visibleFormHtml = (html) => {
  if (html == null) return "";
  const raw = String(html).trim();
  if (raw === "" || raw.toLowerCase() === "null") return "";
  const cleaned = raw
    .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
    .replace(/^(?:<br\s*\/?>\s*)+/gi, "")
    .replace(/(?:<br\s*\/?>\s*)+$/gi, "")
    .trim();
  if (!cleaned) return "";
  if (stripHtmlToPlainText(cleaned) || /<img\b/i.test(cleaned)) return cleaned;
  return "";
};

export const convertLabel = (arr) => {
  const newArr = arr.map((some) => {
    return {
      name: some.name.charAt(0).toUpperCase() + some.name.slice(1) || "",
      label: some.name.charAt(0).toUpperCase() + some.name.slice(1) || "",
      value: some.name.charAt(0).toUpperCase() + some.name.slice(1) || "",
      id: some.id || "",
    };
  });
  newArr.unshift({ label: "All", id: "all", value: "all", name: "all" });
  return newArr;
};

export const convertLabelToSelect = (arr) => {
  const newArr = arr.map((some) => {
    return {
      id: some.uuid,
      name: `${some.first_name} ${some.last_name}`,
      label: `${some.first_name} ${some.last_name}`,
      value: `${some.first_name} ${some.last_name}`,
    };
  });
  return [modifiedObj, ...newArr];
};

export const NumberWithInternationalSign = (
  count,
  withAbbr = false,
  decimals = 0
) => {
  const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
  if (i.toString().includes("Infinity")) return count;
  let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
  if (withAbbr) {
    result += `${COUNT_ABBRS[i]}`;
  }
  return result;
};

export const validDate = (date) => {
  let dateformat = /^(0?[1-9]|[1-2][0-9]|3[01])[\/](0?[1-9]|1[0-2])/;

  // Matching the date through regular expression
  if (date.match(dateformat)) {
    let operator = date.split("/");

    // Extract the string into month, date and year
    let datepart = [];
    if (operator.length > 1) {
      datepart = date.split("/");
    }
    let day = parseInt(datepart[0]);
    let month = parseInt(datepart[1]);
    let year = parseInt(datepart[2]);

    let ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 1 || month > 2) {
      if (day > ListofDays[month - 1]) {
        return false;
      }
    } else if (month === 2) {
      let leapYear = false;
      if ((!(year % 4) && year % 100) || !(year % 400)) leapYear = true;
      if (leapYear === false && day >= 29) {
        return false;
      } else if (leapYear === true && day > 29) {
        return false;
      }
    }
  } else {
    return false;
  }
  return true;
};

export const gethoursAndMins = (hr = 0, min = 0) => {
  let ttl = "";
  if (typeof hr === "string" && typeof min === "string") {
    return `${hr}:${min}`;
  }
  const isNegative = hr < 0 || min < 0;
  if (isNegative) {
    hr = Math.abs(hr);
    min = Math.abs(min);
  }

  if (hr < 10) {
    ttl = `0${hr}:`;
  } else {
    ttl = `${hr}:`;
  }
  if (min < 10) {
    ttl = `${ttl}0${min}`;
  } else {
    ttl = `${ttl}${min}`;
  }
  return isNegative ? `-${ttl}` : ttl;
};

export const getParticipantCrmFormApiPrefix = () => {
  if (roleAccess([USER_ROLE.Sp_Standard_User])) {
    return "worker";
  }
  return getUrlRole();
};

export const getFormSubTabForParticipantProfile = (parentSlug) =>
  resolveParticipantFormSubTabByParentSlug(parentSlug);
export const getFormSubTabForHRM = (parentSlug) => {
  if (!parentSlug) return false;

  let parentTabForm = "";
  if (parentSlug) {
    if (parentSlug === "training-and-development") {
      parentTabForm = WORKER_PROFILE_TABS.find((x) => x.id === 9);
      return parentTabForm;
    } else {
      parentTabForm = WORKER_PROFILE_TABS.find((x) => x.id === 4);

      if (
        parentTabForm &&
        parentTabForm.children &&
        parentTabForm.children.length > 0
      ) {
        const subMenuSlug = parentTabForm.children.find(
          (x) => x.slug && x.slug === parentSlug
        );
        return subMenuSlug ? subMenuSlug : false;
      }
    }
  }

  return false;
};

export const getFormSubTabForSilProfile = (parentSlug) => {
  if (!parentSlug) return false;
  let parentTabForm = "";
  if (parentSlug !== PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.SLUG) {
    parentTabForm = SIL_HOME_PROFILE_TABS.find((x) => x.id === "forms");
    if (
      parentTabForm &&
      parentTabForm.children &&
      parentTabForm.children.length > 0
    ) {
      const subMenuSlug = parentTabForm.children.find(
        (x) => x.slug && x.slug === parentSlug
      );
      return subMenuSlug ? subMenuSlug : false;
    }
  }

  return false;
};

export const changeDateToYearMonthDay = (date) => {
  if (!date) return;
  return moment(date).format("YYYY-MM-DD");
};

/** ISO week (Mon–Sun), aligned with DateRangePickerNew locale. */
export const getCurrentWeekDateRange = () => ({
  fromDate: moment().startOf("isoWeek").format("YYYY-MM-DD"),
  toDate: moment().endOf("isoWeek").format("YYYY-MM-DD"),
});
export const changeDateFormat = (date) => {
  if (!date) return;
  return moment(date).format("DD/MM/YYYY");
};

export const convertStringyfyIntoJSON = (valueInStringyfy) => {
  let JsonData = valueInStringyfy;
  const parseInJson = (data) => {
    if (data) {
      if (typeof data === "string") {
        return JSON.parse(data);
      } else {
        return data;
      }
    }
    return null;
  };

  if (JsonData) {
    do {
      JsonData = parseInJson(JsonData);
    } while (typeof parseInJson(JsonData) === "string");
  }

  return JsonData ? JsonData : [];
};

export const capitalizeFirstLetter = (string) => {
  if (string == null || string === undefined) return "";
  const str = typeof string === "string" ? string : String(string);
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeAllLetters = (string) => {
  if (!string || string === undefined) return "";
  return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
    letter.toUpperCase()
  );
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export const checkPasswordValidity = (value) => {
  const isNonWhiteSpace = /^\S*$/;
  if (!isNonWhiteSpace.test(value)) {
    return "Password must not contain Whitespaces.";
  }

  const isContainsUppercase = /^(?=.*[A-Z]).*$/;
  if (!isContainsUppercase.test(value)) {
    return "Password must have at least one Uppercase Character.";
  }

  const isContainsLowercase = /^(?=.*[a-z]).*$/;
  if (!isContainsLowercase.test(value)) {
    return "Password must have at least one Lowercase Character.";
  }

  const isContainsNumber = /^(?=.*[0-9]).*$/;
  if (!isContainsNumber.test(value)) {
    return "Password must contain at least one Digit.";
  }

  const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
  if (!isContainsSymbol.test(value)) {
    return "Password must contain at least one Special Symbol.";
  }

  const isValidLength = /^.{8,16}$/;
  if (!isValidLength.test(value)) {
    return "Password must be 8-16 Characters Long.";
  }

  return null;
};

export const getUserTypeFromLC = () => {
  return localStorage.getItem("userType")
    ? localStorage.getItem("userType")
    : null;
};

/** Extract care_sector from login user, SP payload, or nested settings shapes. */
export const extractCareSector = (data) => {
  if (!data || typeof data !== "object") return null;
  return (
    data.care_sector ||
    data.settings?.care_sector ||
    data.general_settings?.care_sector ||
    null
  );
};

/** Resolve care sector from a login user payload (user + nested service_provider). */
export const resolveLoginCareSector = (user) =>
  extractCareSector(user) || extractCareSector(user?.service_provider);

/** Sync read of org care sector for sidebar labels before API settings load. */
export const getCachedCareSector = () => {
  try {
    const cached = localStorage.getItem("spCareSector");
    if (cached) return cached;
    const spSettings = JSON.parse(localStorage.getItem("spSettings") || "null");
    const fromSpSettings = extractCareSector(spSettings);
    if (fromSpSettings) return fromSpSettings;
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return resolveLoginCareSector(user);
  } catch (_) {
    /* ignore parse errors */
  }
  return null;
};

export const cacheCareSector = (careSectorOrSource) => {
  const careSector =
    typeof careSectorOrSource === "string"
      ? careSectorOrSource
      : resolveLoginCareSector(careSectorOrSource) ||
        extractCareSector(careSectorOrSource);
  if (careSector) {
    localStorage.setItem("spCareSector", careSector);
  }
};

export const getUserRoleTitle = (role) => {
  if (!role) return "";
  return USER_ROLE_TITLE[role];
};

export const validateCurrentDate = (
  fieldValueDate,
  currentDate,
  dates,
  isRegex
) => {
  if (!Array.isArray(dates)) return DUMMY_REGEX_EXP;
  if (
    dates.find((x) => x === "future") &&
    dates.find((x) => x === "past") &&
    dates.find((x) => x === "present") &&
    fieldValueDate
  ) {
    return false;
  }
  if (
    dates.find((x) => x === "past") &&
    dates.find((x) => x === "present") &&
    fieldValueDate
  ) {
    const isValid = currentDate.isSameOrBefore(fieldValueDate);
    if (!isValid) return false;
    return isValid && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be greater than today";
  }
  if (
    dates.find((x) => x === "future") &&
    dates.find((x) => x === "present") &&
    fieldValueDate
  ) {
    const isValid = fieldValueDate.diff(currentDate, "days");
    if (isValid >= 0) return false;
    return isValid < 0 && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be less than today";
  }
  if (
    dates.find((x) => x === "future") &&
    dates.find((x) => x === "past") &&
    fieldValueDate
  ) {
    const isValid = moment(currentDate).isSame(moment(fieldValueDate), "day");
    if (!isValid) return false;
    return isValid && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be today date";
  }
  if (dates.find((x) => x === "past") && fieldValueDate) {
    const isValid = currentDate.diff(fieldValueDate, "days");
    if (isValid > 0) return false;
    return isValid <= 0 && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be equal or greater than today";
  }
  if (dates.find((x) => x === "present") && fieldValueDate) {
    const isValid = moment(currentDate).isSame(moment(fieldValueDate), "day");
    if (isValid) return false;
    return !isValid && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be less or greater than today";
  }
  if (dates.find((x) => x === "future") && fieldValueDate) {
    const isValid = fieldValueDate.isAfter(currentDate, "days");
    if (isValid) return false;
    return !isValid && isRegex
      ? DUMMY_REGEX_EXP
      : "Date should not be equal or less than today";
  }
  return DUMMY_REGEX_EXP;
};

export const formatDateIntoDMY = (date) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY");
};

export const formatDateIntoDMYToDisplay = (date, format = "DD-MMM-YYYY") => {
  if (!date) return "";
  return moment(date).format(format);
};

/**
 * Splits a DD-MMM-YYYY display string so the year can wrap as a single unit
 * (avoids breaking "2026" across lines).
 *
 * @param {string} formatted - Output from formatDateIntoDMYToDisplay
 * @returns {{ prefix: string, year: string, full: string }}
 */
export const splitDmyDisplayDatePrefixAndYear = (formatted) => {
  if (!formatted) {
    return { prefix: "", year: "", full: "" };
  }
  const i = formatted.lastIndexOf("-");
  if (i === -1) {
    return { prefix: formatted, year: "", full: formatted };
  }
  return {
    full: formatted,
    prefix: formatted.slice(0, i + 1),
    year: formatted.slice(i + 1),
  };
};

export const formatDateIntoDMYHMS = (date) => {
  if (!date) return "";
  // const currentTimeZone = momentTimeZone.tz.guess();
  // const dateVal = momentTimeZone(date).tz(currentTimeZone);
  const dateWithoutTAndTimezone = date.replace("T", " ").substring(0, 19);
  return moment(dateWithoutTAndTimezone).format("DD-MM-YYYY, h:mm:ss A");
};

export const formatDateIntoDMMMY = (date) => {
  if (!date) return "";
  return moment(date).format("Do MMM YYYY");
};
export const formatDateIntoDMM = (date) => {
  if (!date) return "";
  return moment(date).format("Do MMM");
};

export const getError = (
  errors,
  inputFieldLabel,
  index = null,
  inputIndex = null,
  subInputIndex = null
) => {
  if (
    inputFieldLabel &&
    !isNaN(index) &&
    !isNaN(inputIndex) &&
    subInputIndex === null
  ) {
    return (
      errors?.template?.[index]?.input_fields?.[inputIndex]?.[
        `${convertLabelIntoName(inputFieldLabel)}`
      ]?.type === "required" && (
        <span className='text-sm text-red-500'>This field is required!</span>
      )
    );
  }
  if (
    inputFieldLabel &&
    !isNaN(index) &&
    !isNaN(inputIndex) &&
    !isNaN(subInputIndex)
  ) {
    return (
      errors?.template?.[index]?.input_fields?.[inputIndex]?.sub_section[
        subInputIndex
      ]?.[`${convertLabelIntoName(inputFieldLabel)}`]?.type === "required" && (
        <span className='text-sm text-red-500'>This field is required!</span>
      )
    );
  }
  return null;
};

export const getPlanManagedBy = (data) => {
  if (!data) return "-";
  const val = convertStringyfyIntoJSON(data);
  if (val && isArray(val) && val.length > 0) {
    return val.map((x) => x?.label).join(", ");
  } else if (val && !isArray(val)) {
    return val.hasOwnProperty("label") ? val.label : "-";
  }
  return "-";
};

export const getShiftLength = (
  start_time,
  end_time,
  Format_HH_MM = false,
  isCheckValidate = false
) => {
  if (
    start_time &&
    start_time !== null &&
    end_time &&
    end_time !== null &&
    end_time !== undefined
  ) {
    const time1 = moment(start_time, "HH:mm");
    const time2 = moment(end_time, "HH:mm");

    let difference = 0;

    if (time2.isBefore(time1)) {
      time2.add(1, "day");
    }

    difference = time2.diff(time1, "minutes");

    const hours = Math.floor(difference / 60);
    const remainingMinutes = difference % 60;

    const time = gethoursAndMins(hours, remainingMinutes);

    if (isCheckValidate === true) {
      return time && time.includes(":")
        ? `${time.split(":")[0]}:${time.split(":")[1]}` !== "00:00"
        : false;
    }
    if (Format_HH_MM) {
      return time && time.includes(":")
        ? `${time.split(":")[0]}:${time.split(":")[1]}`
        : null;
    }
    return time && time.includes(":")
      ? `${time.split(":")[0]}h:${time.split(":")[1]}m`
      : null;
  }
  return null;
};

export function calculateTotalShiftLength(
  start_time,
  end_time,
  isGreaterThan = false
) {
  if (!start_time || !end_time) return "00h:00m";

  const start = moment(start_time, "YYYY-MM-DD HH:mm:ss");
  const end = moment(end_time, "YYYY-MM-DD HH:mm:ss");
  const duration = moment.duration(end.diff(start));

  const totalMinutes = duration.asMinutes();
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);
  if (isGreaterThan && (hours > 10 || hours > 8)) {
    return hours;
  }
  return `${hours}h:${minutes}m`;
}

export const isBase64Encoded = (str) => {
  if (str === null || str === "") return false;
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  return base64Regex.test(str);
};

export const convertTimeToDatetimeLocal = (
  shiftDate,
  timeValue,
  isNextDay = false
) => {
  if (!timeValue) return "";
  // Use moment to handle date consistently and avoid timezone issues
  const baseDate = moment(shiftDate).startOf('day');
  
  // Parse time in both 12-hour (hh:mm A) and 24-hour (HH:mm) formats
  const parseFormats = ["HH:mm", "hh:mm A", "h:mm A"];
  const timeMoment = moment(timeValue, parseFormats, true);
  
  if (!timeMoment.isValid()) {
    // Fallback: try simple parsing if moment parsing fails
    const timeParts = timeValue.match(/(\d+):(\d+)\s*(AM|PM)?/i);
    if (timeParts) {
      let hours = parseInt(timeParts[1]);
      const minutes = parseInt(timeParts[2]);
      const period = timeParts[3]?.toUpperCase();
      if (period === 'PM' && hours !== 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;
      let currentDate = baseDate.clone().hours(hours).minutes(minutes).seconds(0).milliseconds(0);
      if (isNextDay) {
        currentDate = currentDate.add(1, 'day');
      }
      return currentDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    }
    return "";
  }

  // Set the hours and minutes using moment
  let currentDate = baseDate.clone()
    .hours(timeMoment.hours())
    .minutes(timeMoment.minutes())
    .seconds(0)
    .milliseconds(0);

  // If it's the next day, increment the date by 1 day
  if (isNextDay) {
    currentDate = currentDate.add(1, 'day');
  }

  // Return the formatted date string
  return currentDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};
export const convertTimeToDatetimeLocalForTesting = (
  shiftDate,
  timeValue,
  isNextDay = false
) => {
  if (!timeValue) return "";

  // Use moment to handle various date formats reliably, treating it as UTC
  const currentDate = moment.utc(shiftDate); // Treat as UTC to avoid timezone shifts

  const [hours, minutes] = timeValue.split(":").map(Number); // Convert to numbers

  // Set the hours and minutes
  currentDate.set("hour", hours);
  currentDate.set("minute", minutes);
  currentDate.set("second", 0);
  currentDate.set("millisecond", 0);

  // If it's the next day, increment the date
  if (isNextDay) {
    currentDate.add(1, "days");
  }

  // Return the formatted date string in UTC without timezone shift
  return currentDate.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};

export const convertTimeToDatetimeLocalWithoutMoment = (
  shiftDate,
  timeValue,
  isNextDay = false
) => {
  if (!timeValue || !shiftDate) return "";
  let currentDate;
  if (shiftDate && shiftDate?.includes("T")) {
    const [date, time] = shiftDate?.split("T");

    const [year, month, day] = date?.split("-").map(Number);
    const [hours, minutes] = timeValue.split(":").map(Number);

    currentDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
  } else {
    const [date, time] = shiftDate?.split(" ");

    const [year, month, day] = date?.split("-").map(Number);
    const [hours, minutes] = timeValue.split(":").map(Number);
    currentDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
  }

  if (isNextDay) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  const pad = (num) => num.toString().padStart(2, "0");
  const formattedYear = currentDate.getFullYear();
  const formattedMonth = pad(currentDate.getMonth() + 1);
  const formattedDay = pad(currentDate.getDate());
  const formattedHours = pad(currentDate.getHours());
  const formattedMinutes = pad(currentDate.getMinutes());
  const formattedSeconds = pad(currentDate.getSeconds());
  const formattedMilliseconds = currentDate
    .getMilliseconds()
    .toString()
    .padStart(3, "0");

  const formattedDate = `${formattedYear}-${formattedMonth}-${formattedDay}T${formattedHours}:${formattedMinutes}:${formattedSeconds}.${formattedMilliseconds}`;

  return formattedDate;
};
export const isCheckNextDayShift = (shift_date, start_time, end_time) => {
  if (
    shift_date &&
    shift_date !== null &&
    start_time &&
    start_time !== null &&
    end_time &&
    end_time !== null &&
    end_time !== undefined
  ) {
    // Parse time in both 12-hour (hh:mm A) and 24-hour (HH:mm) formats
    const parseFormats = ["HH:mm", "hh:mm A", "h:mm A"];
    const time1 = moment(start_time, parseFormats, true);
    const time2 = moment(end_time, parseFormats, true);

    if (!time1.isValid() || !time2.isValid()) {
      return false;
    }

    // Compare times - if end time is before or equal to start time, it's next day
    if (time2.diff(time1, "minutes") <= 0) {
      // Convert end_time to 24-hour format for convertTimeToDatetimeLocal
      const endTime24Hour = time2.format("HH:mm");
      return convertTimeToDatetimeLocal(shift_date, endTime24Hour, true);
    }
    return false;
  }
  return false;
};

export const getHrAndMinsFormatting = (value) => {
  if (!value) return "";
  if (value.includes(":")) {
    return `${value.split(":")[0]}${value.split(":")[0] > 1 ? "hrs" : "hr"}${
      value.split(":")[1]
    }${value.split(":")[1] > 1 ? "mins" : "min"}`;
  }
  return "00hr00min";
};

// Function to convert 24-hour time to 12-hour time with AM and PM
export const convertTo12HourFormat = (time24) => {
  if (time24 === null || typeof time24 === "undefined") {
    return "";
  }

  const [hours, minutes] = time24.split(":");
  let period = "AM";

  let hours12 = parseInt(hours, 10);

  if (hours12 >= 12) {
    period = "PM";
    if (hours12 > 12) {
      hours12 -= 12;
    }
  }

  return `${hours12}:${minutes} ${period}`;
};

export const formatDateTimeWithAMPM = (date) => {
  const currentDate = new Date(date);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[currentDate.getMonth()]; // Get month name
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours() % 12 || 12).padStart(2, "0"); // Convert to 12-hour format
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const ampm = currentDate.getHours() >= 12 ? "PM" : "AM";

  const formattedDateTime = `${hours}:${minutes} ${ampm} `;

  return formattedDateTime;
};

export function formatDateToAustralian(date) {
  const currentDate = new Date(date);
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  return currentDate.toLocaleDateString("en-AU", options);
}

export function isDateBeforeToday(dateString) {
  const dateToCheck = new Date(dateString); // Convert the input date string to a Date object
  const today = new Date(); // Get the current date

  // Compare the input date with today's date
  return dateToCheck < today;
}
export const getTimesheetProgressLabel = (value) => {
  if (value) {
    const arr = Object.keys(TIMESHEET_PROGRESS_STATUS).map(
      (key) => TIMESHEET_PROGRESS_STATUS[key]
    );
    return arr.find((x) => x.value === value)?.label ?? "";
  }
  return "";
};

export const formatTimeSheetLength = (
  totalSeconds = null,
  format = "digit"
) => {
  const hours = Math.floor(totalSeconds / 3600);
  if (totalSeconds === null) return null;
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  if (format === "digit") {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }

  return `${hours.toString().padStart(2, "0")}${
    hours.toString().padStart(2, "0") > 1 ? "hrs" : "hr"
  }${minutes.toString().padStart(2, "0")}${
    minutes.toString().padStart(2, "0") > 1 ? "mins" : "min"
  }`;
};

export const checkDisabilityOfShiftStatus = (status, progress) => {
  if (status && progress) {
    // return status === SHIFT_STATUS.EXPIRED || status === SHIFT_STATUS.ACCEPTED
    return status === SHIFT_STATUS.ACCEPTED && progress === "un_submitted"
      ? true
      : false;
  }
  return false;
};

/**
 * Shared Schedule edit/delete lock: invoice generated OR timesheet approved.
 * Flags come from calendar/shift-detail payloads (is_locked / is_invoiced / is_timesheet_approved).
 */
export const isShiftMutationLocked = (shift) => {
  if (!shift) return false;
  return (
    parseBooleanVal(shift?.is_locked ?? shift?.meta?.is_locked) ||
    parseBooleanVal(shift?.is_invoiced ?? shift?.meta?.is_invoiced) ||
    parseBooleanVal(
      shift?.is_timesheet_approved ?? shift?.meta?.is_timesheet_approved
    )
  );
};

const isPermissionRoot = (item) =>
  item?.parent_id === null || item?.parent_id === undefined;

const permissionBelongsToParent = (child, parent) =>
  child?.parent_id != null &&
  parent?.id != null &&
  String(child.parent_id) === String(parent.id);

export const flattenGroupedPermissions = (permissions) => {
  if (!permissions) {
    return [];
  }
  if (Array.isArray(permissions)) {
    return permissions;
  }
  if (typeof permissions !== "object") {
    return [];
  }

  const seen = new Set();
  const entries = [];
  Object.values(permissions).forEach((group) => {
    if (!Array.isArray(group)) {
      return;
    }
    group.forEach((entry) => {
      const key = entry?.id ?? entry?.name;
      if (key != null && seen.has(key)) {
        return;
      }
      if (key != null) {
        seen.add(key);
      }
      entries.push(entry);
    });
  });
  return entries;
};

export const groupByPermissionsByName = (permissions = []) => {
  const groupedPermissions = permissions.reduce((result, item) => {
    if (isPermissionRoot(item)) {
      let name = item.name;
      if (item.name === "participant.dashboard") {
        name = "dashboard";
      } else if (item.name.includes("crm.form")) {
        name = "crm_form";
      } else if (item.name.includes("hrm.form")) {
        name = "hrm_form";
      } else if (item.name.includes(".")) {
        name = item.name.split(".")[0];
      } else {
        name = item.name;
      }

      result[name] = [
        item,
        ...permissions.filter((child) => permissionBelongsToParent(child, item)),
      ];
    }
    return result;
  }, {});

  return groupedPermissions;
};
export const checkRunningShiftStatus = (status) => {
  if (status) {
    // return status === SHIFT_STATUS.ACCEPTED || status === SHIFT_STATUS.NA
    return status === SHIFT_STATUS.NA ? true : false;
  }
  return false;
};

export const downloadFileFromServer = async (fileUrl, fileName) => {
  try {
    if (fileUrl && fileName) {
      const response = await fetch(sanitizeDocumentUrl(baseURLImage(fileUrl)));
      const blob = await response.blob();
      FileSaver.saveAs(blob, fileName);
    }
    return null;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const isExistPayrollPlatform = (type = "") => {
  return Object.values(PAYROLL_PLATFORMS).findIndex((x) => x === type) !== -1;
};

export const hasCheckTimesheetStatus = (
  item = {},
  statusToCheck = "success"
) => {
  return Object.values(PAYROLL_PLATFORMS).some(
    (platform) => item[`${platform}_export_status`] === statusToCheck
  );
};

export const checkWorkerAnyTimesheetsFailedOrError = (data = []) => {
  return data.filter((item) => {
    const payrollStatuses = Object.values(PAYROLL_PLATFORMS).map(
      (platform) => item[`${platform}_export_status`]
    );
    return payrollStatuses.some(
      (status) =>
        status === PAYROLL_EXPORT_STATUS.FAILED ||
        status === PAYROLL_EXPORT_STATUS.ERROR
    );
  });
};

export const checkWorkerAllTimesheetsSuccess = (data = []) => {
  return data.filter((item) => {
    const payrollStatuses = Object.values(PAYROLL_PLATFORMS).map(
      (platform) => item[`${platform}_export_status`]
    );
    return payrollStatuses.some(
      (status) => status === PAYROLL_EXPORT_STATUS.SUCCESS
    );
  });
};

export const getAllNonSuccessTimesheets = (data = []) => {
  return data.filter((item) => {
    const payrollStatuses = Object.values(PAYROLL_PLATFORMS).map(
      (platform) => item[`${platform}_export_status`]
    );
    return !payrollStatuses.some(
      (status) => status === PAYROLL_EXPORT_STATUS.SUCCESS
    );
  });
};

export const filterNonPayrollRecords = (item = {}) => {
  return Object.values(PAYROLL_PLATFORMS).some(
    (platform) => !_.isEmpty(item?.[`${platform}_worker_id`] || null)
  );
};

export const getPayrollPlatformByUsingWorkerId = (item) => {
  return (
    (item &&
      Object.entries(PAYROLL_PLATFORMS).find(
        ([_, platform]) => !!item?.[`${platform}_worker_id`]
      ))?.[1] || null
  );
};

export const currentLoggedInIdAndUUID = (isAddSpAdmin = false) => {
  const currentSpUser = store?.getState()?.spAdmin?.getIn(["spSetting"]);
  let currentLoggedInUser = store?.getState()?.users?.getIn(["user"]);
  if (currentLoggedInUser) {
    const data = JSON.parse(JSON.stringify(currentLoggedInUser));
    currentLoggedInUser = data;
  }
  if (
    parseBooleanVal(isAddSpAdmin) &&
    roleAccess([USER_ROLE.Sp_Admin]) &&
    currentSpUser &&
    currentSpUser?.id
  ) {
    return { id: currentSpUser.id, uuid: currentSpUser.uuid };
  } else if (
    parseBooleanVal(isAddSpAdmin) &&
    currentLoggedInUser &&
    !roleAccess([USER_ROLE.Sp_Admin]) &&
    currentLoggedInUser?.id &&
    currentLoggedInUser?.uuid
  ) {
    return {
      id:
        currentLoggedInUser?.sp_id || currentLoggedInUser?.service_provider?.id,
      uuid: currentLoggedInUser.uuid,
    };
  } else if (
    currentLoggedInUser &&
    currentLoggedInUser?.id &&
    isAddSpAdmin === false
  ) {
    return { id: currentLoggedInUser.id, uuid: currentLoggedInUser.uuid };
  }
  return false;
};

export const convertCentsToDollars = (cents) => {
  return cents / 100;
};

export const getRemainingTrialDays = (trialEndDate) => {
  if (!trialEndDate) return;
  const today = moment().startOf("day");
  const end = moment(trialEndDate).startOf("day");
  // const end = moment("2024-02-14").startOf("day");

  const remainingDays = end.diff(today, "days");
  return remainingDays;
};

export const getExpireDate = (trialEndDate) => {
  if (!trialEndDate) return;
  const end = moment(trialEndDate);
  const formattedDate = end.format("Do MMMM YYYY");
  return formattedDate;
};

export const formatAmount = (amount) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export function customFormatDate(dateString) {
  if (dateString === null || typeof dateString === "undefined") {
    return "";
  }

  const separator = dateString.includes("T") ? "T" : " ";

  const [datePart] = dateString.split(separator);
  const [year, month, day] = datePart.split("-");

  return `${day}/${month}/${year}`;
}

export function completeFormatDate(dateString) {
  const [datePart, timePart] = dateString.split("T");

  const [year, month, day] = datePart.split("-");

  const time = timePart ? timePart.split(".")[0] : "00:00:00";

  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}

export function convertTimeToDatetimeWithLocal(time) {
  return moment(time).local().format("YYYY-MM-DDTHH:mm:ss");
}

export const alreadyNextDate = (startDate, endDate) => {
  const startDateTime = new Date(`${startDate}`);
  const endDateTime = new Date(`${endDate}`);

  return endDateTime.getDate() > startDateTime.getDate();
};

export const formatDateForWorkerTime = (dateTimeString) => {
  if (!dateTimeString) return;
  // Extract the date part from the dateTimeString
  const datePart = dateTimeString?.split(" ")[0];

  // Split the date part into year, month, and day
  const [year, month, day] = datePart?.split("-");

  // Return the formatted date
  return `${day}-${month}-${year}`;
};
export function getFileExtensionForDocuments(url) {
  if (!url) {
    return "";
  }

  let extension = url.split(".").pop();
  extension = extension.split(/[?#]/)[0];
  return extension || "";
}

export const parsePriceInfo = (input, PricingType) => {
  let regex = "";

  if (PricingType?.interval === "year") {
    regex =
      /^(\d+)\s+to\s+(\d+)\s+Participants\s+\$([\d.]+)\s+(.*?)\/(Year(?:s)?)$/i;
  } else {
    regex =
      /^(\d+)\s+to\s+(\d+)\s+Participants\s+\$([\d.]+)\s+(.*?)\s+\((\d+)\s+Year(?:s)?\)$/i;
  }

  const match = regex.exec(input);

  if (!match) {
    return null;
  }
  if (PricingType?.interval !== "year") {
    const [, rangeStart, rangeEnd, amount, additionalText, duration] = match;
    return {
      description: `${rangeStart} to ${rangeEnd} Participants`,
      amount,
      frequency: additionalText,
      year: duration,
    };
  } else if (PricingType?.interval === "year") {
    const [, rangeStart, rangeEnd, amount, additionalText, duration] = match;
    return {
      description: `${rangeStart} to ${rangeEnd} Participants`,
      amount,
      frequency: additionalText,
      year: duration,
    };
  }
};

export function formatDateForApprovedTimesheet(dateString) {
  if (!dateString) return;

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract components from the date string
  const year = dateString.slice(2, 4);
  const month = parseInt(dateString.slice(5, 7), 10);
  const day = parseInt(dateString.slice(8, 10), 10);
  let hours = parseInt(dateString.slice(11, 13), 10);
  const minutes = parseInt(dateString.slice(14, 16), 10);

  // Convert 24-hour time to 12-hour time
  const suffix = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  // Add appropriate suffix to the day
  const getDayWithSuffix = (day) => {
    if (day > 3 && day < 21) return day + "th";
    switch (day % 10) {
      case 1:
        return day + "st";
      case 2:
        return day + "nd";
      case 3:
        return day + "rd";
      default:
        return day + "th";
    }
  };

  const dayWithSuffix = getDayWithSuffix(day);

  // Format the minutes to always be two digits
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  // Build and return the final formatted string
  return `${dayWithSuffix} ${
    months[month - 1]
  } ${year} - ${hours}:${formattedMinutes} ${suffix}`;
}

export const getCurrentTimezone = () => {
  return momentTimeZone.tz.guess();
};

/** Standard display: 03 Jun 2026, 10:41 am (client timezone). */
export const CLIENT_DATETIME_FORMAT = "DD MMM YYYY, h:mm a";

export const CLIENT_DATE_FORMAT = "DD MMM YYYY";

const DETAIL_DATETIME_FIELD_PATTERN =
  /(?:^|_)(?:date|time|timestamp)(?:$|_)|_at$|^at$|(?:^|_)dob(?:$|_)|birth|expir|sent_at|login_at|started_at|ended_at/i;

const DETAIL_NON_DATETIME_FIELD_PATTERN = /_by$|_id$|^id$/i;

/** Rostering fields stored as naive local time — display as entered, no TZ shift. */
const WALL_CLOCK_AUDIT_FIELD_PATTERN =
  /^(start_time|end_time|worker_start_time|worker_end_time|shift_date|time_sheet_date|timesheet_date)$/i;

const formatWallClockDateTime = (str) => {
  const hasTime =
    /[T ]\d{2}:\d{2}/.test(str) || /:\d{2}/.test(str.split(" ").pop() || "");
  const stripped = str
    .replace(/Z$/i, "")
    .replace(/([+-]\d{2}:?\d{2})$/, "")
    .replace(/\.\d{1,6}$/, "")
    .trim()
    .replace("T", " ");

  const parsed = momentTimeZone(
    stripped,
    [
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DD H:mm:ss",
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD H:mm",
      "YYYY-MM-DD",
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY H:mm:ss",
    ],
    true
  );

  if (!parsed.isValid()) {
    return str;
  }

  return parsed.format(hasTime ? CLIENT_DATETIME_FORMAT : CLIENT_DATE_FORMAT);
};

const looksLikeDateTimeString = (value) => {
  if (typeof value !== "string") return false;
  const str = value.trim();
  if (!str) return false;
  return (
    /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}|$)/.test(str) ||
    /^\d{4}-\d{2}-\d{2}T/.test(str) ||
    /^\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4}(\s+\d{1,2}:\d{2})?/.test(str)
  );
};

/** Format audit/detail field values that are dates or datetimes. Returns null if not a date. */
export const tryFormatDetailDateTime = (val, field = "") => {
  if (val === null || val === undefined) return null;
  if (typeof val === "boolean" || typeof val === "object") return null;

  const str = String(val).trim();
  if (!str) return null;

  if (DETAIL_NON_DATETIME_FIELD_PATTERN.test(field || "")) return null;

  if (WALL_CLOCK_AUDIT_FIELD_PATTERN.test(field || "")) {
    return formatWallClockDateTime(str);
  }

  const fieldHint = DETAIL_DATETIME_FIELD_PATTERN.test(field || "");
  const valueHint = looksLikeDateTimeString(str);
  if (!fieldHint && !valueHint) return null;

  const hasTime =
    /[T ]\d{2}:\d{2}/.test(str) || /:\d{2}/.test(str.split(" ").pop() || "");

  const parsed = momentTimeZone.utc(str);
  if (!parsed.isValid()) {
    const local = momentTimeZone(str);
    if (!local.isValid()) return null;
    return local
      .tz(getCurrentTimezone())
      .format(hasTime ? CLIENT_DATETIME_FORMAT : CLIENT_DATE_FORMAT);
  }

  return parsed
    .tz(getCurrentTimezone())
    .format(hasTime ? CLIENT_DATETIME_FORMAT : CLIENT_DATE_FORMAT);
};

/** Format a UTC API datetime in the browser/client timezone (en-AU style). */
export const formatDateTimeInClientTimezone = (
  dateStr,
  format = CLIENT_DATETIME_FORMAT
) => {
  if (!dateStr) return "—";
  const parsed = momentTimeZone.utc(dateStr);
  if (!parsed.isValid()) return "—";
  return parsed.tz(getCurrentTimezone()).format(format);
};

export const formatTimeInClientTimezone = (dateStr) =>
  formatDateTimeInClientTimezone(dateStr, CLIENT_DATETIME_FORMAT);

export const exportTOExcel = async (exportData, options = {}) => {
  if (!exportData || exportData === undefined) return "";

  trackFeatureUse("report_excel_export", {
    report_type: options.reportType ?? null,
  });

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8;";
  const fileExtenstion = ".xlsx";

  const ws = XLSX.utils.json_to_sheet(exportData);

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const data = new Blob([excelBuffer], { type: fileType });

  await FileSaver.saveAs(data, "Excel-Export" + fileExtenstion);
};

export const downloadParticipantTemplate = async (
  careSector = null,
  templateFilePath = null
) => {
  const downloadFileName = getParticipantImportTemplateFileName(careSector);
  // Use provided path, or fall back to configured path, or generate template
  const filePath = templateFilePath || PARTICIPANT_IMPORT_TEMPLATE_PATH;
  
  // If a specific template file path is configured or provided, download that file instead
  if (filePath) {
    try {
      // Use backend endpoint to avoid CORS issues
      const rolePrefix = getUrlRole();
      const endpoint = `${rolePrefix}/import-data/download-template?type=participant`;
      
      const response = await apiGetRequest(endpoint, null, {
        responseType: 'blob'
      });
      
      if (response && response.data) {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        FileSaver.saveAs(blob, downloadFileName);
        return;
      }
    } catch (error) {
      console.error("Error downloading template from backend:", error);
      // Try direct S3 download as fallback
      try {
        await downloadFileFromServer(filePath, downloadFileName);
        return;
      } catch (s3Error) {
        console.error("Error downloading template from S3:", s3Error);
        // Fall back to generated template if both fail
      }
    }
  }

  // Generate template programmatically (fallback or default behavior)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8;";
  const fileExtension = ".xlsx";

  // Define headers based on backend expectations
  // Note: Asterisks are removed from headers as they're only visual indicators
  // Backend expects field names without asterisks
  // However, we add asterisk to first_name in the template for visual indication
  const headers = [
    "*first_name",
    "*last_name",
    "gender",
    "primary_email_address",
    "primary_phone_number",
    "secondary_phone_number",
    "*ndis_no",
    "date_of_birth",
    "street_address",
    "suburb",
    "state",
    "postcode",
  ];

  // Create worksheet with headers only
  const ws = XLSX.utils.aoa_to_sheet([headers]);

  // Set column widths for better readability
  const colWidths = headers.map((header) => {
    // Wider columns for longer headers
    if (header.includes("email") || header.includes("address") || header.includes("phone")) {
      return { wch: 25 };
    }
    return { wch: 20 };
  });
  ws["!cols"] = colWidths;

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });

  await FileSaver.saveAs(data, downloadFileName.replace(/\.xlsx$/i, "") + fileExtension);
};

export const downloadWorkerTemplate = async (templateFilePath = null) => {
  // Use provided path, or fall back to configured path, or generate template
  const filePath = templateFilePath || WORKER_IMPORT_TEMPLATE_PATH;
  
  // If a specific template file path is configured or provided, download that file instead
  if (filePath) {
    try {
      // Use backend endpoint to avoid CORS issues
      const rolePrefix = getUrlRole();
      const endpoint = `${rolePrefix}/import-data/download-template?type=worker`;
      
      const response = await apiGetRequest(endpoint, null, {
        responseType: 'blob'
      });
      
      if (response && response.data) {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        FileSaver.saveAs(blob, "worker_import_template.xlsx");
        return;
      }
    } catch (error) {
      console.error("Error downloading template from backend:", error);
      // Try direct S3 download as fallback
      try {
        await downloadFileFromServer(filePath, "worker_import_template.xlsx");
        return;
      } catch (s3Error) {
        console.error("Error downloading template from S3:", s3Error);
        // Fall back to generated template if both fail
      }
    }
  }

  // Generate template programmatically (fallback or default behavior)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8;";
  const fileExtension = ".xlsx";

  // Define headers based on backend expectations
  // Note: Asterisks are removed from headers as they're only visual indicators
  // Backend expects field names without asterisks
  // However, we add asterisks to mandatory fields in the template for visual indication
  const headers = [
    "*first_name",
    "*last_name",
    "*email",
    "password",
    "*job_title",
    "*role",
    "date_of_birth",
    "*joining_date",
    "gender",
    "*phone_number",
    "secondary_phone_number",
    "emergency_contact_name",
    "emergency_contact_number",
    "street_address",
    "*suburb",
    "state",
    "country",
    "postal_code",
    "salary_slab",
    "hourly_rate",
    "role_type",
    "risk_assessed_roles",
    "quick_snapshot",
    "performance_review_required",
  ];

  // Create worksheet with headers only
  const ws = XLSX.utils.aoa_to_sheet([headers]);

  // Find the role column index
  const roleColumnIndex = headers.findIndex(h => h === "*role");
  
  // Set column widths for better readability
  const colWidths = headers.map((header) => {
    // Wider columns for longer headers
    if (header.includes("emergency") || header.includes("address") || header.includes("phone") || header.includes("snapshot") || header.includes("review")) {
      return { wch: 25 };
    }
    if (header.includes("email") || header.includes("salary") || header.includes("hourly") || header.includes("assessed")) {
      return { wch: 22 };
    }
    if (header === "*role") {
      return { wch: 25 }; // Wider for role column
    }
    return { wch: 18 };
  });
  ws["!cols"] = colWidths;

  // Create a helper sheet with role options for dropdown
  const roleOptions = ["support coordinator", "support worker", "allied health worker"];
  const roleOptionsSheet = XLSX.utils.aoa_to_sheet([roleOptions]);
  
  // Create workbook with both sheets
  const wb = { 
    Sheets: { 
      data: ws, 
      roles: roleOptionsSheet 
    }, 
    SheetNames: ["data", "roles"] 
  };

  // Add data validation for role column using the helper sheet
  // Note: XLSX.js has limited support for data validation, but we'll try using sheet reference
  if (roleColumnIndex >= 0) {
    const roleColumnLetter = XLSX.utils.encode_col(roleColumnIndex);
    
    // Use helper sheet reference format (more reliable than comma-separated)
    // Format: roles!$A$1:$A$3 references the roles sheet cells A1 to A3
    const validationRange = {
      sqref: `${roleColumnLetter}2:${roleColumnLetter}1000`,
      type: "list",
      formula1: `roles!$A$1:$A$${roleOptions.length}`,
      showDropDown: true,
      showInputMessage: true,
      promptTitle: "Select Role",
      prompt: "Please select one of the following roles: support coordinator, support worker, or allied health worker",
      showError: true,
      errorStyle: "stop",
      errorTitle: "Invalid Role",
      error: "Please select a valid role from the dropdown list."
    };
    
    // Add data validation to worksheet
    if (!ws["!dataValidations"]) {
      ws["!dataValidations"] = [];
    }
    ws["!dataValidations"].push(validationRange);
  }

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });

  await FileSaver.saveAs(data, "worker_import_template" + fileExtension);
};

/**
 * Validates participant import file for required fields
 * @param {File} file - The Excel file to validate
 * @returns {Promise<{isValid: boolean, message: string}>}
 */
export const validateParticipantImportFile = async (file, careSector) => {
  const participantLabel = getParticipantLabel(careSector, false).toLowerCase();
  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    
    // Convert to JSON with header row
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
    
    if (jsonData.length === 0) {
      return {
        isValid: false,
        message: "The file is empty. Please ensure the file contains data rows."
      };
    }
    
    // Get headers from first row, filter out empty/null/undefined values and normalize
    const headers = jsonData[0]
      .map(h => {
        if (h === null || h === undefined) return "";
        // Remove asterisks and normalize: convert to lowercase, trim, replace spaces with underscores
        return String(h).replace(/\*/g, '').toLowerCase().trim().replace(/\s+/g, '_');
      })
      .filter(h => h !== "");
    
    // Debug: Log headers found (can be removed in production)
    console.log("Participant file headers found:", headers);
    
    // Required fields for participant import (header validation)
    const requiredHeaderFields = ['first_name', 'last_name', 'ndis_no'];
    const missingFields = [];
    
    requiredHeaderFields.forEach(field => {
      // Check exact match or with underscores/spaces variations
      const normalizedField = field.toLowerCase().trim();
      const found = headers.some(h => {
        const normalizedHeader = h.toLowerCase().trim();
        return normalizedHeader === normalizedField || 
               normalizedHeader.replace(/[_\s]/g, '') === normalizedField.replace(/[_\s]/g, '');
      });
      
      if (!found) {
        missingFields.push(field);
      }
    });
    
    if (missingFields.length > 0) {
      return {
        isValid: false,
        message: `Missing required column(s): ${missingFields.join(', ')}. Found columns: ${headers.join(', ')}. Please ensure all required columns are present in the file.`
      };
    }
    
    // Check if there's at least one data row (header + at least 1 data row)
    if (jsonData.length < 2) {
      return {
        isValid: false,
        message: `The file contains headers but no data rows. Please add at least one ${participantLabel} record.`
      };
    }
    
    // Check if mandatory fields have data in rows
    const requiredDataFields = ['first_name', 'last_name', 'ndis_no'];
    const missingDataErrors = [];
    
    // Determine if first data row (index 1) is a dummy row
    // A dummy row typically has empty or placeholder values for required fields
    const firstDataRow = jsonData[1];
    const firstRowData = {};
    headers.forEach((header, index) => {
      const normalizedHeader = header.toLowerCase().trim();
      firstRowData[normalizedHeader] = firstDataRow[index] !== undefined && firstDataRow[index] !== null ? String(firstDataRow[index]).trim() : '';
    });
    
    // Check if first row has required field data - if not, it's likely a dummy row
    const firstRowHasData = requiredDataFields.some(field => {
      const normalizedField = field.toLowerCase().trim();
      const value = firstRowData[normalizedField];
      return value && value !== '';
    });
    
    // Start validation from index 1 if first row has data, otherwise from index 2 (skip dummy row)
    const startIndex = firstRowHasData ? 1 : 2;
    
    // Check each data row
    for (let i = startIndex; i < jsonData.length; i++) {
      const row = jsonData[i];
      const rowData = {};
      
      // Map row data to headers
      headers.forEach((header, index) => {
        const normalizedHeader = header.toLowerCase().trim();
        rowData[normalizedHeader] = row[index] !== undefined && row[index] !== null ? String(row[index]).trim() : '';
      });
      
      // Check each required field
      requiredDataFields.forEach(field => {
        const normalizedField = field.toLowerCase().trim();
        const value = rowData[normalizedField];
        
        if (!value || value === '') {
          const rowNumber = i + 1; // Excel row number (1-indexed, +1 for header)
          missingDataErrors.push(`Row ${rowNumber}: ${field} is missing`);
        }
      });
    }
    
    if (missingDataErrors.length > 0) {
      const errorCount = missingDataErrors.length;
      const errorList = missingDataErrors.slice(0, 10).join('; ');
      const moreText = errorCount > 10 ? ` and ${errorCount - 10} more error(s)` : '';
      return {
        isValid: false,
        message: `Missing mandatory field data: ${errorList}${moreText}. Please ensure all mandatory fields are filled in.`
      };
    }
    
    return { isValid: true, message: "File validation passed." };
  } catch (error) {
    console.error("Validation error:", error);
    return {
      isValid: false,
      message: `Error reading file: ${error.message}. Please ensure the file is a valid Excel file (.xlsx, .xls, or .csv).`
    };
  }
};

/**
 * Validates worker import file for required fields
 * @param {File} file - The Excel file to validate
 * @returns {Promise<{isValid: boolean, message: string}>}
 */
export const validateWorkerImportFile = async (file) => {
  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    
    // Convert to JSON with header row
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
    
    if (jsonData.length === 0) {
      return {
        isValid: false,
        message: "The file is empty. Please ensure the file contains data rows."
      };
    }
    
    // Get headers from first row, filter out empty/null/undefined values and normalize
    const headers = jsonData[0]
      .map(h => {
        if (h === null || h === undefined) return "";
        // Remove asterisks and normalize: convert to lowercase, trim, replace spaces with underscores
        return String(h).replace(/\*/g, '').toLowerCase().trim().replace(/\s+/g, '_');
      })
      .filter(h => h !== "");
    
    // Debug: Log headers found (can be removed in production)
    console.log("Worker file headers found:", headers);
    
    // Required fields for worker import (header validation)
    // Note: password is optional (defaults to Vertex@360 in backend), so not included in validation
    const requiredHeaderFields = ['first_name', 'last_name', 'email', 'job_title', 'role', 'joining_date', 'phone_number', 'suburb'];
    const missingFields = [];
    
    requiredHeaderFields.forEach(field => {
      // Check exact match or with underscores/spaces variations
      const normalizedField = field.toLowerCase().trim();
      const found = headers.some(h => {
        const normalizedHeader = h.toLowerCase().trim();
        return normalizedHeader === normalizedField || 
               normalizedHeader.replace(/[_\s]/g, '') === normalizedField.replace(/[_\s]/g, '');
      });
      
      if (!found) {
        missingFields.push(field);
      }
    });
    
    if (missingFields.length > 0) {
      return {
        isValid: false,
        message: `Missing required column(s): ${missingFields.join(', ')}. Found columns: ${headers.join(', ')}. Please ensure all required columns are present in the file.`
      };
    }
    
    // Check if there's at least one data row (header + at least 1 data row)
    if (jsonData.length < 2) {
      return {
        isValid: false,
        message: "The file contains headers but no data rows. Please add at least one worker record."
      };
    }
    
    // Check if mandatory fields have data in rows
    // Note: password is optional (defaults to Vertex@360 in backend), so not included in data validation
    const requiredDataFields = ['first_name', 'last_name', 'email', 'job_title', 'role', 'joining_date', 'phone_number', 'suburb'];
    const missingDataErrors = [];
    
    // Determine if first data row (index 1) is a dummy row
    // A dummy row typically has empty or placeholder values for required fields
    const firstDataRow = jsonData[1];
    const firstRowData = {};
    headers.forEach((header, index) => {
      const normalizedHeader = header.toLowerCase().trim();
      firstRowData[normalizedHeader] = firstDataRow[index] !== undefined && firstDataRow[index] !== null ? String(firstDataRow[index]).trim() : '';
    });
    
    // Check if first row has required field data - if not, it's likely a dummy row
    const firstRowHasData = requiredDataFields.some(field => {
      const normalizedField = field.toLowerCase().trim();
      const value = firstRowData[normalizedField];
      return value && value !== '';
    });
    
    // Start validation from index 1 if first row has data, otherwise from index 2 (skip dummy row)
    const startIndex = firstRowHasData ? 1 : 2;
    
    // Check each data row
    for (let i = startIndex; i < jsonData.length; i++) {
      const row = jsonData[i];
      const rowData = {};
      
      // Map row data to headers
      headers.forEach((header, index) => {
        const normalizedHeader = header.toLowerCase().trim();
        rowData[normalizedHeader] = row[index] !== undefined && row[index] !== null ? String(row[index]).trim() : '';
      });
      
      // Check each required field
      requiredDataFields.forEach(field => {
        const normalizedField = field.toLowerCase().trim();
        const value = rowData[normalizedField];
        
        if (!value || value === '') {
          const rowNumber = i + 1; // Excel row number (1-indexed, +1 for header)
          missingDataErrors.push(`Row ${rowNumber}: ${field} is missing`);
        }
      });
    }
    
    if (missingDataErrors.length > 0) {
      const errorCount = missingDataErrors.length;
      const errorList = missingDataErrors.slice(0, 10).join('; ');
      const moreText = errorCount > 10 ? ` and ${errorCount - 10} more error(s)` : '';
      return {
        isValid: false,
        message: `Missing mandatory field data: ${errorList}${moreText}. Please ensure all mandatory fields are filled in.`
      };
    }
    
    return { isValid: true, message: "File validation passed." };
  } catch (error) {
    console.error("Validation error:", error);
    return {
      isValid: false,
      message: `Error reading file: ${error.message}. Please ensure the file is a valid Excel file (.xlsx, .xls, or .csv).`
    };
  }
};

export const formatDateReporting = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getWorkerTimesheetLength = (workerStartTime, workerEndTime) => {
  if (!workerStartTime || !workerEndTime) return null;

  const startTime = new Date(workerStartTime);
  const endTime = new Date(workerEndTime);

  const diffInMs = endTime - startTime;

  const totalMinutes = diffInMs / (1000 * 60);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);

  return `${hours}h ${minutes}m`;
};

export const getTimesheetLength = (workerStartTime, workerEndTime) => {
  if (!workerStartTime || !workerEndTime) return null;

  const startTime = new Date(workerStartTime);
  const endTime = new Date(workerEndTime);

  const diffInMs = endTime - startTime;
  const totalMinutes = diffInMs / (1000 * 60);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours}.${formattedMinutes}`;
};

export const formatDateForWorkerStartTime = (dateString) => {
  if (typeof dateString !== "string" || dateString.trim() === "") {
    return "";
  }

  const datePart = dateString.split(" ")[0];

  if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    return "";
  }

  const [year, month, day] = datePart.split("-");

  if (
    !year ||
    !month ||
    !day ||
    year.length !== 4 ||
    month.length !== 2 ||
    day.length !== 2
  ) {
    return "";
  }

  return `${day}/${month}/${year}`;
};

export const getDifferenceArray = (array1 = [], array2 = [], key = "value") => {
  const set2 = new Set(array2.map((item) => item[key]));

  return array1.filter((item) => !set2.has(item[key]));
};

export const addMonths = (date, months) => {
  if (!date || !months) return "";
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + months);
  return newDate;
};

/** Default week/fortnight range from SP rostering calendar settings. */
export const getRosteringDefaultDateRange = (spRosteringSetting) => {
  if (!spRosteringSetting) return null;

  if (spRosteringSetting.calendar_type === "weekly") {
    const startOfWeek = moment().startOf("isoWeek");
    const endOfWeek = moment(startOfWeek).endOf("isoWeek");
    return {
      fromDate: startOfWeek.format("YYYY-MM-DD"),
      toDate: endOfWeek.format("YYYY-MM-DD"),
    };
  }

  const today = moment();
  if (spRosteringSetting.default_fortnight === "f1") {
    const referenceMonday = moment("2025-01-06");
    const daysSinceRef = today.diff(referenceMonday, "days");
    const fortnightsSinceRef = Math.floor(daysSinceRef / 14);
    const currentMonday = moment(referenceMonday).add(
      fortnightsSinceRef * 14,
      "days"
    );
    return {
      fromDate: currentMonday.format("YYYY-MM-DD"),
      toDate: moment(currentMonday).add(13, "days").format("YYYY-MM-DD"),
    };
  }

  if (spRosteringSetting.default_fortnight === "f2") {
    const referenceMondayPrevious = moment("2025-01-13");
    const daysSinceRefPrevious = today.diff(referenceMondayPrevious, "days");
    const fortnightsSinceRefPrevious = Math.floor(daysSinceRefPrevious / 14);
    const previousMonday = moment(referenceMondayPrevious).add(
      fortnightsSinceRefPrevious * 14,
      "days"
    );
    return {
      fromDate: previousMonday.format("YYYY-MM-DD"),
      toDate: moment(previousMonday).add(13, "days").format("YYYY-MM-DD"),
    };
  }

  return null;
};

export const addWeeks = (date, weeks) => {
  if (!date || !weeks) return "";
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + weeks * 7);
  return newDate;
};

export const addDays = (date, days) => {
  if (!date || !days) return "";
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

export const truncateTextReporting = (text, maxTextLength = 10) => {
  if (text?.length > maxTextLength) {
    return `${text.substring(0, maxTextLength)}...`;
  }
  return text;
};

export const fetchOptionsForWorkerAndParticpant = async (selectFor,isServiceSupport=[]) => {
  try {
    const serviceSupportList = Array.isArray(isServiceSupport)
      ? isServiceSupport
      : isServiceSupport
        ? [isServiceSupport]
        : [];

    const payload = {
      filters: { search: "", page: 1, per_page: 1000 },
      bodyFilter:{
        status:[ selectFor === "worker" ?  true : "active"]
      }
    };
   
if(serviceSupportList.length > 0){
    Object.assign(payload.bodyFilter,{participant_type: serviceSupportList.map(x=>x.value)});

    }
    const response =
      selectFor === "worker"
        ? await api.teamManagmentListRequest(payload)
        : await api.participantListRequest(payload);

    if (selectFor === "worker") {
      return (
        response.data?.employees?.data?.map((item) => ({
          ...item,
          label: capitalizeAllLetters(`${item.first_name} ${item.last_name}`),
          value: item.uuid,
          icon: item?.photo
            ? baseURLImage(item.photo)
            : getNameProfile(item.first_name, item.last_name || " "),
        })) || []
      );
    }
    return (
      (response.data?.participant ?? response.data?.data?.participant)?.data?.map((item) => ({
        ...item,
        label: capitalizeAllLetters(`${item.first_name} ${item.last_name}`),
        value: item.uuid,
        icon: item?.profile_picture
          ? baseURLImage(item.profile_picture)
          : getNameProfile(item.first_name, item.last_name || " "),
      })) || []
    );
  } catch (error) {
    console.error("Error fetching options:", error);
    return [];
  }
};

export const getFileNameAndExtension = (url) => {
  if (!url) return { fileName: "", extension: "" };

  const fileNameWithExtension = url.split("/").pop();
  const lastDotIndex = fileNameWithExtension.lastIndexOf(".");

  return {
    fileName:
      lastDotIndex === -1
        ? fileNameWithExtension
        : fileNameWithExtension.slice(0, lastDotIndex),
    extension:
      lastDotIndex === -1 ? "" : fileNameWithExtension.slice(lastDotIndex),
  };
};

export const getMimeType = (extension) => {
  return MIME_TYPES[extension.toLowerCase()] || "application/octet-stream";
};

export const getFileFromServerAsFileType = async (url, file_name = null) => {
  try {
    const { fileName, extension } = getFileNameAndExtension(
      file_name ? file_name : url
    );
    const fileType = getMimeType(extension);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }

    const blob = await response.blob();

    const file = new File([blob], `${fileName}${extension}`, {
      type: fileType,
    });

    return file;
  } catch (error) {
    console.error("Error fetching file:", error);
    throw error;
  }
};

export function CustomFormatDateForReporting(dateString) {
  if (!dateString) return;
  const [day, month, year] = dateString.split("-");

  return `${day}/${month}/${year}`;
}

export function CapitalizeLabel(string) {
  if (!string || string === undefined) return "";

  const label = string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return label;
}

export const convertDaysName = (days) => {
  if (typeof days !== "object" || !days) {
    return [];
  }

  const dayMapping = {
    Mon: "monday",
    Tue: "tuesday",
    Wed: "wednesday",
    Thu: "thursday",
    Fri: "friday",
    Sat: "saturday",
    Sun: "sunday",
  };

  const result = Object.entries(days)
    .filter(([key, value]) => value)
    .map(([key]) => dayMapping[key]);

  return result;
};

export const formatRecurringValue = (value) => {
  if (!value) return;

  const [firstPart, secondPart] = value.split("_");
  return `${firstPart} ${secondPart || ""}`.trim();
};

export const convertWeeksToFormat = (value) => {
  if (!value) return;
  const modifiedVal = value.split(" ");
  const quantity = modifiedVal[0];
  const unit = modifiedVal[1].toLowerCase();

  let formattedUnit;
  if (unit.startsWith("week")) {
    formattedUnit = "Week";
  } else if (unit.startsWith("fortnight")) {
    formattedUnit = "Fortnight";
  } else if (unit.startsWith("month")) {
    formattedUnit = "Month";
  } else {
    return null;
  }

  return `${quantity}_${formattedUnit}`;
};

export const calculateTotalHoursAndMinutes = (startTime, endTime) => {
  if (!startTime || !endTime) {
    return "";
  }

  const start = moment(startTime, "HH:mm");
  const end = moment(endTime, "HH:mm");

  if (end.isBefore(start)) {
    end.add(1, "day");
  }

  const duration = moment.duration(end.diff(start));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const calculateTotalDuration = (breakdown) => {
  if (!breakdown) return;
  let totalSeconds = 0;

  breakdown.forEach((item) => {
    if (!item?.duration) return;

    const [hours, minutes, seconds] = item.duration.split(":").map(Number);
    totalSeconds += hours * 3600 + minutes * 60 + seconds;
  });

  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
  const totalSecondsRemainder = totalSeconds % 60;

  return `${String(totalHours).padStart(2, "0")}:${String(
    totalMinutes
  ).padStart(2, "0")}:${String(totalSecondsRemainder).padStart(2, "0")}`;
};

export const calculateDurationStartAndEndTime = (startTime, endTime) => {
  if (!startTime || !endTime) {
    return "00:00:00";
  }

  const start = moment(startTime, "HH:mm");
  let end = moment(endTime, "HH:mm");

  if (end.isBefore(start)) {
    end = end.add(1, "day");
  }

  const duration = moment.duration(end.diff(start));

  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:00`;
};

export const embedDateWithTime = (time, baseDateTime) => {
  if (!time || !baseDateTime) return "00:00:00";
  let baseDate;
  if (baseDateTime?.includes("T")) {
    baseDate = baseDateTime?.split("T")[0];
  } else {
    baseDate = baseDateTime?.split(" ")[0];
  }

  // const baseDate = moment(baseDateTime).format("YYYY-MM-DD");
  const modifiedTime = moment(`${baseDate} ${time}`, "YYYY-MM-DD HH:mm").format(
    "YYYY-MM-DD HH:mm"
  );

  return modifiedTime;
};

export const showToastMessage = (message, toastId) => {
  setTimeout(() => {
    if (!toast.isActive(toastId)) {
      toast.warning(message, { toastId: toastId });
    }
  }, 200);
};

export const extractFileNameFromS3URL = (url) => {
  if (!url) return;

  const parts = url.split("/");
  const fileNameWithExt = parts[parts.length - 1];

  const actualFileName =
    fileNameWithExt.slice(0, fileNameWithExt.lastIndexOf(".")) ||
    fileNameWithExt;

  return actualFileName;
};

export const DATA_FORMATTER_FOR_DYNAMICS_FORMS = (template, Index = 0) => {
  if (!template) return;

  const data = _.cloneDeep(template);
  let temp = JSON.parse(data);

  for (let j = 0; j < temp[Index].input_fields.length; j++) {
    if (temp[Index].input_fields[j].type === "address") {
      temp[Index].input_fields[j].address = "";
    }
    if (temp[Index].input_fields[j].type === "sub_section") {
      temp[Index].input_fields[j].sub_fields.forEach((item, k) => {
        if (temp[Index].input_fields[j].sub_fields[k].type === "address") {
          temp[Index].input_fields[j].sub_fields[k].address = "";
        }
        if (
          temp[Index].input_fields[j].sub_fields[k].type === "file" ||
          temp[Index].input_fields[j].sub_fields[k].type === "signature" ||
          temp[Index].input_fields[j].sub_fields[k].type === "content"
        ) {
          return null;
        }
        if (item.type === "table") {
          const rowDataTemp = _.cloneDeep(
            temp[Index].input_fields[j].sub_fields[k].rows
          );
          let rows = [];
          temp[Index].input_fields[j].sub_fields[k].rows.forEach(
            (rowData, rowIndex) => {
              rows.push([]);
              rowDataTemp[rowIndex].forEach((columnData, columnIndex) => {
                rows[rowIndex].push({});

                Object.assign(rowDataTemp[rowIndex][columnIndex], {
                  value: "",
                });
                Object.assign(rows[rowIndex][columnIndex], {
                  ...rowDataTemp[rowIndex][columnIndex],
                });
              });
            }
          );
          Object.assign(temp[Index].input_fields[j].sub_fields[k], {
            rows: [...rows],
          });
        } else {
          item.value = "";
        }
      });
    }
    if (
      temp[Index].input_fields[j].type === "signature" ||
      temp[Index].input_fields[j].type === "file" ||
      temp[Index].input_fields[j].type === "content"
    ) {
      continue;
    }
    if (temp[Index].input_fields[j].type === "table") {
      const rowDataTemp = _.cloneDeep(temp[Index].input_fields[j].rows);
      let rows = [];
      temp[Index].input_fields[j].rows.forEach((rowData, rowIndex) => {
        rows.push([]);
        rowDataTemp[rowIndex].forEach((columnData, columnIndex) => {
          rows[rowIndex].push({});

          Object.assign(rowDataTemp[rowIndex][columnIndex], {
            value: "",
          });
          Object.assign(rows[rowIndex][columnIndex], {
            ...rowDataTemp[rowIndex][columnIndex],
          });
        });
      });
      Object.assign(temp[Index].input_fields[j], { rows: [...rows] });
    } else {
      temp[Index].input_fields[j].value = "";
    }
  }

  return [...temp];
};

export function capitalizeWords(str) {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const getDayMonthTableHeader = (startDate, endDate) => {
  if (!startDate || !endDate) return [];

  const start = moment(startDate);
  const end = moment(endDate);
  const dayMonthTableHeader = [];

  for (let currentDate = start; currentDate <= end; currentDate.add(1, "day")) {
    dayMonthTableHeader.push(currentDate.format("YYYY-MM-DD"));
  }

  return dayMonthTableHeader;
};
export function validateImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = function () {
      if (this.width > 500) {
        reject(
          "Image too wide. The maximum width allowed is 500px. Please resize and try again."
        );
      } else {
        resolve();
      }
    };
  });
}

export function convertTimeToHrsMins(timeStr) {
  if (!timeStr) return "";
  const [hours, minutes] = timeStr.split(":").map(Number);
  return `${hours}Hrs ${minutes} mins`;
}

export function extractTimeFromDateTime(datetimeStr) {
  if (!datetimeStr || typeof datetimeStr !== "string") return "";

  const parts = datetimeStr?.includes("T")
    ? datetimeStr.split("T")
    : datetimeStr.split(" ");
  if (parts.length !== 2) return "";

  const timePart = parts[1];

  return timePart.slice(0, 5);
}

//for new timesheet design
export const isEndTimeNextDay = (date, startTime, endTime, end_date = "") => {
  if (!date || !startTime || !endTime) return;

  if (
    date !== "" &&
    end_date !== "" &&
    !moment(date).isSame(moment(end_date), "day")
  ) {
    return true;
  }

  const modifiedDate = date?.split(" ");

  const startDateTime = moment(
    `${modifiedDate[0]} ${startTime}`,
    "YYYY-MM-DD HH:mm"
  );
  const endDateTime = moment(
    `${modifiedDate[0]} ${endTime}`,
    "YYYY-MM-DD HH:mm"
  );
  if (
    endDateTime.isBefore(startDateTime) ||
    (endDateTime.isSame(startDateTime, "day") &&
      endDateTime.isBefore(startDateTime, "hour"))
  ) {
    return true;
  }

  return false;
};

export function convertToAMPM(timeString) {
  if (!timeString) return;

  const date = new Date(timeString); // Convert the string to a Date object
  let hours = date.getUTCHours(); // Use getUTCHours instead of getHours
  let minutes = date.getUTCMinutes(); // Use getUTCMinutes instead of getMinutes
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;

  const formattedTime = hours + ":" + minutes + " " + ampm;
  return formattedTime;
}

export const formatHours = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");

  const formattedHours =
    parseInt(hours, 10) >= 0 ? hours.padStart(2, "0") : "00";
  const formattedMinutes =
    parseInt(minutes, 10) >= 0 ? minutes.padStart(2, "0") : "00";

  return `${formattedHours}:${formattedMinutes}`;
};

export function calculateDuration(startTime, endTime) {
  const start = moment(startTime);
  let end = moment(endTime);

  // If end time is before start time, add one day to end time
  if (end.isBefore(start)) {
    end = end.add(1, "days");
  }

  const duration = moment.duration(end.diff(start));

  // Use asHours() so spans ≥ 24h (e.g. STA full-day) are not truncated via hours() % 24.
  const hours = String(Math.floor(duration.asHours())).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const seconds = String(duration.seconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

export const getFortnights = () => {
  let currentMonday = moment().startOf("week").isoWeekday(1);
  const endOfFortnight = moment(currentMonday).add(13, "days");
  if (moment().isAfter(endOfFortnight)) {
    currentMonday = currentMonday.add(13, "days");
  }
  const previousMonday = moment(currentMonday).subtract(7, "days");
  return {
    current: {
      start: currentMonday,
      end: moment(currentMonday).add(13, "days"),
    },
    previous: {
      start: previousMonday,
      end: moment(previousMonday).add(13, "days"),
    },
  };
};

export const dateModifiedForTimesheet = (date) => {
  if (!date) return "";
  let datePart = "";
  let exactDate="";

  const longDateRegex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4}/;

  if (longDateRegex.test(date)) {

    const d = new Date(date);
    if (!isNaN(d.getTime())) {

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  exactDate = `${year}-${month}-${day}T00:00:00`;
    }
  } else{
    exactDate = date;
  }


  if (exactDate && exactDate?.includes("T")) {
    datePart = exactDate.split("T")[0];
  } else if (exactDate && exactDate?.includes(" ")) {
    datePart = exactDate.split(" ")[0];
  }


  if(datePart?.includes("/")){
     const [year, month, day] = datePart.split("/");

  return `${day}/${month}/${year}`;
  } else if(datePart?.includes("-")){
     const [year, month, day] = datePart.split("-");

  return `${day}/${month}/${year}`;
  }

  // Fallback: try parsing with moment for any other format (e.g. locale strings, ISO variants)
  if (date && typeof date === "string") {
    const parsed = moment(date);
    if (parsed.isValid()) {
      return parsed.format("DD/MM/YYYY");
    }
  }
  return "";
};

// export const dateModifiedForTimesheet = (date) => {
//   if (!date) return "";
//   let datePart = "";
// console.log(date,"date");
//   // Remove time if present
//   if (date.includes("T")) {
//     datePart = date.split("T")[0];
//   } else if (date.includes(" ")) {
//     datePart = date.split(" ")[0];
//   } else {
//     datePart = date;
//   }

//   let day, month, year;

//   if (datePart.includes("/")) {
//     const parts = datePart.split("/");
//     if (parts[0].length === 4) {

//       year = parts[0]; month = parts[1]; day = parts[2];
//     } else if (parts[2].length === 4) {

//       day = parts[0]; month = parts[1]; year = parts[2];
//     }
//     return `${day}/${month}/${year}`;
//   }

//   if (datePart.includes("-")) {
//     const parts = datePart.split("-");
//     if (parts[0].length === 4) {

//       year = parts[0]; month = parts[1]; day = parts[2];
//     } else if (parts[2].length === 4) {

//       day = parts[0]; month = parts[1]; year = parts[2];
//     }
//     return `${day}/${month}/${year}`;
//   }

//   // // If already in single string, try to parse
//   // if (datePart.length === 8 && !isNaN(datePart)) {
//   //   // e.g. 20250912
//   //   year = datePart.slice(0,4);
//   //   month = datePart.slice(4,6);
//   //   day = datePart.slice(6,8);
//   //   return `${day}/${month}/${year}`;
//   // }

//   return datePart;
// };

export const manuallyEmbedDateWithTime = (time, baseDateTime) => {

  if (!time || !baseDateTime) return "00:00:00";

  const [day, month, year] = baseDateTime.split("/");

   return `${year}-${month}-${day}T${time}:00.00Z`;
}
/**
 * Truncate to N decimals (no rounding). Matches PHP truncateDecimal:
 * 79.6 * 100 is 7959.999… in IEEE float — Number.EPSILON is too small and
 * used to emit 79.59. 1e-9 lifts that back to 79.60.
 */
export const truncateDecimal = (value, decimals = 2) => {
  if (value === null || value === undefined || value === "") return 0;
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return 0;
  const factor = Math.pow(10, decimals);
  if (numericValue >= 0) {
    return Math.floor(numericValue * factor + 1e-9) / factor;
  }
  return Math.ceil(numericValue * factor - 1e-9) / factor;
};

/** Full-precision hours for money math (no intermediate 2dp truncation). */
export const timeToQuantityExact = (timeStr, sleepover = false) => {
  if (sleepover) return 1;
  if (!timeStr) return 0;

  if (!isNaN(timeStr)) {
    return parseFloat(timeStr);
  }
  const [hours = 0, minutes = 0, seconds = 0] = timeStr.split(":").map((n) => Number(n) || 0);

  return hours + minutes / 60 + seconds / 3600;
};

/** Display/export quantity truncated to 2dp. */
export const timeToQuantity = (timeStr, sleepover = false) => {
  return truncateDecimal(timeToQuantityExact(timeStr, sleepover), 2);
};

/** COS/AH case note total: truncated 2dp hours × hourly rate (00:02 @ $100.14 → $3.00). */
export const caseNoteHoursAmount = (timeStr, hourlyRate) => {
  const quantity = timeToQuantity(timeStr);
  const rate = parseFloat(hourlyRate) || 0;
  return parseFloat((quantity * rate).toFixed(2));
};

/** Sleepover payroll window: 22:00 → 06:00 (1 unit per overlapped night). */
const SLEEPOVER_WINDOW_START_HOUR = 22;
const SLEEPOVER_WINDOW_END_HOUR = 6;

/**
 * Split a clock range into sleepover nights (22:00–06:00) and worked seconds outside that window.
 * @returns {{ sleepoverCount: number, workedSeconds: number }}
 */
export const splitSleepoverPayrollWindow = (startInput, endInput) => {
  const rangeStart = moment(startInput);
  const rangeEnd = moment(endInput);
  if (
    !rangeStart.isValid() ||
    !rangeEnd.isValid() ||
    !rangeEnd.isAfter(rangeStart)
  ) {
    return { sleepoverCount: 0, workedSeconds: 0 };
  }

  const sleepIntervals = [];
  const cursor = rangeStart.clone().startOf("day").subtract(1, "day");
  const lastDay = rangeEnd.clone().startOf("day");

  while (!cursor.isAfter(lastDay, "day")) {
    const windowStart = cursor
      .clone()
      .hour(SLEEPOVER_WINDOW_START_HOUR)
      .minute(0)
      .second(0)
      .millisecond(0);
    const windowEnd = cursor
      .clone()
      .add(1, "day")
      .hour(SLEEPOVER_WINDOW_END_HOUR)
      .minute(0)
      .second(0)
      .millisecond(0);

    const overlapStart = moment.max(rangeStart, windowStart);
    const overlapEnd = moment.min(rangeEnd, windowEnd);
    if (overlapEnd.isAfter(overlapStart)) {
      sleepIntervals.push([overlapStart.clone(), overlapEnd.clone()]);
    }
    cursor.add(1, "day");
  }

  let workedSeconds = 0;
  if (sleepIntervals.length === 0) {
    workedSeconds = rangeEnd.diff(rangeStart, "seconds");
  } else {
    sleepIntervals.sort((a, b) => a[0].valueOf() - b[0].valueOf());
    const merged = [];
    sleepIntervals.forEach(([s, e]) => {
      if (
        merged.length === 0 ||
        s.isAfter(merged[merged.length - 1][1])
      ) {
        merged.push([s, e]);
      } else if (e.isAfter(merged[merged.length - 1][1])) {
        merged[merged.length - 1][1] = e;
      }
    });

    let cursorTs = rangeStart.clone();
    merged.forEach(([s, e]) => {
      if (s.isAfter(cursorTs)) {
        workedSeconds += s.diff(cursorTs, "seconds");
      }
      if (e.isAfter(cursorTs)) {
        cursorTs = e.clone();
      }
    });
    if (cursorTs.isBefore(rangeEnd)) {
      workedSeconds += rangeEnd.diff(cursorTs, "seconds");
    }
  }

  return {
    sleepoverCount: sleepIntervals.length,
    workedSeconds: Math.max(0, workedSeconds),
  };
};

/**
 * Payroll export quantity for a timesheet row.
 * Sleepover: 1 unit per 22:00–06:00 night + hours outside that window (+ active_hours when set).
 * Non-sleepover: timesheet_length.
 */
export const getExportTimesheetPayrollQuantity = (timesheet) => {
  if (!timesheet) return 0;
  if (parseBooleanVal(timesheet.sleepover)) {
    const start = timesheet.start_time;
    const end = timesheet.end_time;
    const split = splitSleepoverPayrollWindow(start, end);
    let quantity = Math.max(1, split.sleepoverCount);
    quantity += split.workedSeconds / 3600;

    const activeRaw = String(timesheet.active_hours ?? "").trim();
    if (activeRaw) {
      const normalized =
        (activeRaw.match(/:/g) || []).length === 1
          ? `${activeRaw}:00`
          : activeRaw;
      let activeQty = timeToQuantity(normalized, false);
      if (activeQty > 0 && activeQty < 1) {
        activeQty = 1;
      }
      quantity += activeQty;
    }
    return truncateDecimal(quantity, 2);
  }
  return timeToQuantity(timesheet.timesheet_length, false);
};

/** Sleepover allowance units only (excludes day/evening outside 22:00–06:00). */
export const getExportTimesheetSleepoverAllowanceUnits = (timesheet) => {
  if (!timesheet || !parseBooleanVal(timesheet.sleepover)) return 0;
  const split = splitSleepoverPayrollWindow(
    timesheet.start_time,
    timesheet.end_time
  );
  return Math.max(1, split.sleepoverCount);
};

/**
 * Worked hours for Export Timesheet time display (sidebar / Total Hours).
 * Sleepover allowance units are excluded — those are shown separately as sleepover count.
 */
export const getExportTimesheetWorkedQuantity = (timesheet) => {
  if (!timesheet) return 0;
  if (parseBooleanVal(timesheet.sleepover)) {
    const split = splitSleepoverPayrollWindow(
      timesheet.start_time,
      timesheet.end_time
    );
    let quantity = split.workedSeconds / 3600;

    const activeRaw = String(timesheet.active_hours ?? "").trim();
    if (activeRaw) {
      const normalized =
        (activeRaw.match(/:/g) || []).length === 1
          ? `${activeRaw}:00`
          : activeRaw;
      let activeQty = timeToQuantity(normalized, false);
      if (activeQty > 0 && activeQty < 1) {
        activeQty = 1;
      }
      quantity += activeQty;
    }
    return truncateDecimal(quantity, 2);
  }
  return timeToQuantity(timesheet.timesheet_length, false);
};

/** Seconds used for Export Timesheet time display (excludes sleepover units). */
export const getExportTimesheetWorkedSeconds = (timesheet) =>
  Math.round(getExportTimesheetWorkedQuantity(timesheet) * 3600);

/** Full payroll quantity in seconds (includes sleepover units) — selection quantity. */
export const getExportTimesheetPayrollSeconds = (timesheet) =>
  Math.round(getExportTimesheetPayrollQuantity(timesheet) * 3600);

/**
 * Subtract 2 hours from a duration string (e.g. for sleepover chargeable time).
 * @param {string} durationStr - "H:mm:ss"
 * @returns {string|null} "H:mm:ss" or null
 */
export const durationMinus2Hours = (durationStr) => {
  if (!durationStr) return null;
  const parts = String(durationStr).split(":").map((n) => Number(n) || 0);
  const [hours = 0, minutes = 0, seconds = 0] = parts;
  const totalMinutes = hours * 60 + minutes + seconds / 60;
  const chargeableMinutes = Math.max(0, totalMinutes - 120);
  const h = Math.floor(chargeableMinutes / 60);
  const m = Math.floor(chargeableMinutes % 60);
  const s = Math.round((chargeableMinutes - Math.floor(chargeableMinutes)) * 60);
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};


/** Convert Immutable.Map / List entries to plain objects. */
export const toPlainObject = (value) => {
  if (value == null || typeof value !== "object") return value;
  if (typeof value.toJS === "function") return value.toJS();
  if (typeof value.toObject === "function") return value.toObject();
  return value;
};

/** Unwrap folder_structure from API / Redux (array or Laravel resource { data: [] }). */
export const extractFolderStructureList = (folderStructure) => {
  const plain = toPlainObject(folderStructure);
  if (!plain) return [];
  if (Array.isArray(plain)) return plain;
  if (Array.isArray(plain.data)) return plain.data;
  if (typeof plain === "object" && (plain.uuid || plain.id || plain.name)) {
    return [plain];
  }
  return [];
};

/** Normalize Redux/Immutable document lists to plain arrays. */
export const toPlainDocumentList = (list) => {
  if (!list) return [];
  if (Array.isArray(list)) {
    return list.map((item) => toPlainObject(item));
  }
  if (typeof list.toJS === "function") {
    const converted = list.toJS();
    if (Array.isArray(converted)) {
      return converted.map((item) => toPlainObject(item));
    }
    if (converted?.data && Array.isArray(converted.data)) {
      return converted.data.map((item) => toPlainObject(item));
    }
    return [];
  }
  if (typeof list.toArray === "function") {
    return list.toArray().map((item) => toPlainObject(item));
  }
  if (list?.data && Array.isArray(list.data)) {
    return list.data.map((item) => toPlainObject(item));
  }
  return [];
};

/** Drop one folder/file row from Redux list state (Immutable-safe). Returns null if nothing to remove. */
export const removeDocumentListItem = (list, removed) => {
  const removedId = removed?.id ?? removed?.uuid;
  if (removedId == null) return null;
  const next = toPlainDocumentList(list).filter((item) => {
    const itemId = item?.id ?? item?.uuid;
    return String(itemId) !== String(removedId);
  });
  return next;
};

const readFolderRowValue = (row, ...keys) => {
  if (!row || typeof row !== "object") return undefined;
  for (const key of keys) {
    let value = row[key];
    if (value === undefined && typeof row.get === "function") {
      value = row.get(key);
    }
    if (value !== undefined && value !== null) return value;
  }
  return undefined;
};

/** Read folder/file counts from a plain or Immutable folder row. */
export const getDocumentFolderCounts = (folder) => {
  const plain = toPlainObject(folder);
  if (!plain || typeof plain !== "object") {
    return { folders_count: 0, files_count: 0 };
  }
  let foldersCount =
    readFolderRowValue(plain, "folders_count", "children_count") ?? 0;
  if (!foldersCount) {
    const children = readFolderRowValue(plain, "children");
    if (Array.isArray(children)) {
      foldersCount = children.length;
    } else if (Array.isArray(children?.data)) {
      foldersCount = children.data.length;
    }
  }
  let filesCount =
    readFolderRowValue(plain, "files_count", "file_managements_count") ?? 0;
  if (!filesCount) {
    const files = readFolderRowValue(plain, "file_managements");
    if (Array.isArray(files)) {
      filesCount = files.length;
    } else if (Array.isArray(files?.data)) {
      filesCount = files.data.length;
    }
  }
  return {
    folders_count: Number(foldersCount) || 0,
    files_count: Number(filesCount) || 0,
  };
};

/** Map API folder counts onto a plain folder item for document UIs. */
export const normalizeDocumentFolderItem = (folder) => {
  if (!folder || typeof folder !== "object") return folder;
  const plain = toPlainObject(folder);
  const counts = getDocumentFolderCounts(plain);
  return {
    ...plain,
    folders_count: counts.folders_count,
    files_count: counts.files_count,
  };
};

/**
 * Build muted folder subtitle, e.g. "3 folders, 2 files".
 * Omits zero counts; returns empty string when both are zero.
 */
export const formatFolderContentsLabel = (foldersCount, filesCount) => {
  const folders = Math.max(0, parseInt(foldersCount, 10) || 0);
  const files = Math.max(0, parseInt(filesCount, 10) || 0);
  const parts = [];
  if (folders > 0) {
    parts.push(`${folders} ${folders === 1 ? "folder" : "folders"}`);
  }
  if (files > 0) {
    parts.push(`${files} ${files === 1 ? "file" : "files"}`);
  }
  return parts.join(", ");
};

/** Normalize folder list API body for Redux (handles nested response.data). */
export const normalizeFolderListApiPayload = (response) => {
  const root = toPlainObject(response) || {};
  const body =
    root.folder_structure !== undefined
      ? root
      : root.data?.folder_structure !== undefined
        ? root.data
        : root.data ?? root;

  const files =
    body.files_managements ??
    body.files_management ??
    root.files_managements ??
    [];

  return {
    folder_structure: extractFolderStructureList(body.folder_structure).map(
      normalizeDocumentFolderItem
    ),
    files_managements: files,
  };
};

export const getInvoiceTimesheetLines = (item) =>
  item?.invoice_timesheets ?? item?.invoiceTimesheets ?? [];

export const durationFromStartEnd = (startTime, endTime) => {
  if (!startTime || !endTime) return null;
  const start = moment(startTime).startOf("minute");
  let end = moment(endTime).startOf("minute");
  if (end.isBefore(start)) {
    end = end.clone().add(1, "day");
  }
  const totalMinutes = end.diff(start, "minutes");
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}:${String(m).padStart(2, "0")}:00`;
};

export const resolveBreakdownDuration = (startTime, endTime, duration) =>
  durationFromStartEnd(startTime, endTime) ?? duration;

/** Sleepover or STA parent lines use unit pricing (qty 1); children stay duration-based. */
export const isRosterInvoiceUnitPriced = ({
  sleepover = false,
  isSta = false,
  parentId = null,
} = {}) => (Boolean(sleepover) || Boolean(isSta)) && parentId == null;

export const quantityFromBreakdown = (startTime, endTime, duration, options = {}) => {
  const { sleepover = false, isSta = false, parentId = null } = options;
  if (isRosterInvoiceUnitPriced({ sleepover, isSta, parentId })) {
    return truncateDecimal(1, 2);
  }
  let resolved = resolveBreakdownDuration(startTime, endTime, duration);
  if (parentId != null) {
    resolved = durationMinus2Hours(resolved);
  }
  return timeToQuantity(resolved, parentId != null ? false : sleepover);
};

/** Full-precision quantity for money math (mirrors backend quantityExactFromBreakdown). */
export const quantityExactFromBreakdown = (startTime, endTime, duration, options = {}) => {
  const { sleepover = false, isSta = false, parentId = null } = options;
  if (isRosterInvoiceUnitPriced({ sleepover, isSta, parentId })) {
    return 1;
  }
  let resolved = resolveBreakdownDuration(startTime, endTime, duration);
  if (parentId != null) {
    resolved = durationMinus2Hours(resolved);
  }
  return timeToQuantityExact(resolved, parentId != null ? false : sleepover);
};

/**
 * Line total: displayed 2dp qty × (catalog × worker ÷ participant), truncate once.
 * 1h 10m at $73.58 → 1.16 × 73.58 = $85.35 (not exact hours → $85.84).
 */
export const rosterInvoiceLineTotal = (duration, rate, totalParticipants = 1, options = {}) => {
  const {
    sleepover = false,
    isSta = false,
    parentId = null,
    startTime = null,
    endTime = null,
  } = options;
  const participants = parseFloat(totalParticipants || 1) || 1;
  if (isRosterInvoiceUnitPriced({ sleepover, isSta, parentId })) {
    return truncateDecimal(parseFloat(rate) / participants);
  }
  const quantity = quantityFromBreakdown(startTime, endTime, duration, {
    sleepover: false,
    isSta: false,
    parentId,
  });
  const perParticipantRate = parseFloat(rate) / participants;
  return truncateDecimal(quantity * perParticipantRate);
};

export const rosterInvoiceTimesheetTotal = (item, totalParticipants = 1) => {
  let sum = 0;
  const participants = parseFloat(totalParticipants || 1);

  getInvoiceTimesheetLines(item).forEach((el) => {
    if (el?.parent_id != null && !(parseFloat(el?.total_amount) > 0)) {
      return;
    }
    const rate = el?.invoice_price ?? el?.rate;
    if (!el?.duration || rate == null || rate === "") {
      return;
    }
    sum += rosterInvoiceLineTotal(el.duration, rate, participants, {
      sleepover: el?.is_sleepover,
      isSta: el?.is_sta,
      parentId: el?.parent_id,
      startTime: el?.start_time,
      endTime: el?.end_time,
    });
  });

  const km = parseFloat(item?.km) || 0;
  if (km > 0) {
    const useAltRate = item?.km_alternative_rate;
    const price = useAltRate
      ? parseFloat(item?.km_price) || 0
      : parseFloat(item?.travel_item?.price) || 0;
    if (item?.km_total != null && item.km_total !== "") {
      const parsed = parseFloat(item.km_total);
      if (!Number.isNaN(parsed)) {
        sum += truncateDecimal(parsed);
      }
    } else if (price > 0) {
      sum += truncateDecimal((km * price) / participants);
    }
  }

  return truncateDecimal(sum);
};

/**
 * Divisor for a roster invoice detail's travel line.
 *
 * V5 advance details store `km` as the participant's own share of the shift's worker
 * km, so km × travel_item_price is already their travel and must not be divided
 * again. `travel_participant_count` is only ever persisted for those details, so its
 * presence — not its value — is what identifies them. Legacy details carry the
 * worker's full km and still split by the detail's participant count.
 */
export const rosterInvoiceTravelDenominator = (item) => {
  if (item?.travel_participant_count != null) return 1;

  return Math.max(1, parseFloat(item?.total_participants ?? 1) || 1);
};

export const rosterInvoiceDetailTotal = (item) => {
  const participants = parseFloat(item?.total_participants || 1);
  let sum = 0;

  getInvoiceTimesheetLines(item).forEach((el) => {
    const rate = el?.rate ?? el?.invoice_price;
    if (!el?.duration || rate == null || rate === "") {
      return;
    }
    sum += rosterInvoiceLineTotal(el.duration, rate, participants, {
      sleepover: el?.is_sleepover,
      isSta: el?.is_sta,
      parentId: null,
      startTime: el?.start_time,
      endTime: el?.end_time,
    });
  });

  if (item?.travel_amount != null && item.travel_amount !== "") {
    const parsed = parseFloat(item.travel_amount);
    if (!Number.isNaN(parsed)) {
      sum += truncateDecimal(parsed);
    }
  } else {
    const km = parseFloat(item?.km) || 0;
    const travelPrice = parseFloat(item?.travel_item_price) || 0;
    if (km > 0 && travelPrice > 0) {
      sum += truncateDecimal(
        (km * travelPrice) / rosterInvoiceTravelDenominator(item)
      );
    }
  }

  return truncateDecimal(sum);
};

export const SLEEPOVER_HOURS_THRESHOLD = 8;

export const parseShiftLengthToSeconds = (shiftLength) => {
  if (!shiftLength || !String(shiftLength).includes(":")) return 0;
  const [hours, minutes, seconds = 0] = String(shiftLength)
    .split(":")
    .map((n) => parseInt(n, 10) || 0);
  return hours * 3600 + minutes * 60 + seconds;
};

const isTruthySleepoverFlag = (value) =>
  value === true || value === 1 || value === "1";

const parseScheduleInstant = (timeValue) => {
  if (!timeValue) return null;
  const zoned = moment.parseZone(timeValue);
  if (zoned.isValid()) return zoned;
  const parsed = moment(timeValue);
  return parsed.isValid() ? parsed : null;
};

const getSecondsFromTimeRange = (
  startTime,
  endTime,
  { sameClockFullDay = false } = {}
) => {
  if (!startTime || !endTime) return 0;
  const start = parseScheduleInstant(startTime);
  const end = parseScheduleInstant(endTime);
  if (!start || !end) return 0;

  const endAdj = end.clone();
  if (endAdj.isBefore(start)) {
    endAdj.add(1, "day");
  } else if (sameClockFullDay && !endAdj.isAfter(start)) {
    // V5/STA: 12:00 AM–12:00 AM is 24 hours, not 0.
    endAdj.add(1, "day");
  }

  const seconds = endAdj.diff(start, "seconds");
  if (seconds > 0) return seconds;
  if (sameClockFullDay && start.format("HH:mm") === end.format("HH:mm")) {
    return 24 * 3600;
  }
  return 0;
};

const applySleepoverToSeconds = (seconds, sleepover) => {
  if (isTruthySleepoverFlag(sleepover)) {
    return getSleepoverCountableSeconds(seconds);
  }
  return seconds;
};

const isAdvanceCalendarShift = (shift) =>
  parseBooleanVal(shift?.is_multi_assignment) || parseBooleanVal(shift?.is_sta);

const fallbackShiftWindowSeconds = (shift) => {
  const fromLength = parseShiftLengthToSeconds(shift?.shift_length);
  if (fromLength > 0) {
    return applySleepoverToSeconds(fromLength, shift?.sleepover);
  }
  return applySleepoverToSeconds(
    getSecondsFromTimeRange(shift?.start_time, shift?.end_time, {
      sameClockFullDay: isAdvanceCalendarShift(shift),
    }),
    shift?.sleepover
  );
};

const secondsFromDurationOrRange = (
  duration,
  startTime,
  endTime,
  { sameClockFullDay = false } = {}
) => {
  const durationSeconds = parseShiftLengthToSeconds(duration);
  if (durationSeconds > 0) return durationSeconds;
  return getSecondsFromTimeRange(startTime, endTime, { sameClockFullDay });
};

const getSleepoverCountableSeconds = (totalSeconds) =>
  Math.max(0, totalSeconds - SLEEPOVER_HOURS_THRESHOLD * 3600);

const sumNonSleepoverSplitSeconds = (splitShifts = []) =>
  splitShifts.reduce((total, split) => {
    if (isTruthySleepoverFlag(split.is_sleepover ?? split.sleepover)) {
      return total;
    }
    return (
      total +
      secondsFromDurationOrRange(
        split.duration,
        split.start_time,
        split.end_time
      )
    );
  }, 0);

const splitParticipantIds = (split) => {
  const ids = [];
  if (Array.isArray(split?.participant_ids)) {
    ids.push(...split.participant_ids);
  }
  if (Array.isArray(split?.participants)) {
    split.participants.forEach((participant) => {
      if (participant == null) return;
      if (typeof participant === "object") {
        ids.push(participant.id);
      } else {
        ids.push(participant);
      }
    });
  }
  if (split?.participant_id != null) ids.push(split.participant_id);
  if (split?.pt_id != null) ids.push(split.pt_id);
  return ids.map((id) => Number(id)).filter((id) => Number.isFinite(id));
};

const splitBelongsToParticipant = (split, participantId) => {
  const target = Number(participantId);
  if (!Number.isFinite(target)) return false;
  return splitParticipantIds(split).some((id) => id === target);
};

const getAdvanceCalendarWorkerAssignments = (shift) => {
  if (Array.isArray(shift?.workers) && shift.workers.length > 0) {
    return shift.workers;
  }
  const assignments =
    shift?.worker_assignments ?? shift?.workerAssignments ?? [];
  return Array.isArray(assignments) ? assignments : [];
};

const getAdvanceWorkerAssignmentSeconds = (shift) => {
  const assignments = getAdvanceCalendarWorkerAssignments(shift);
  const rowWorkerId = Number(
    shift?.calendar_row_worker_id ?? shift?.worker_id ?? shift?.worker?.id
  );
  const withTimes = (entry) =>
    getSecondsFromTimeRange(entry?.start_time, entry?.end_time, {
      sameClockFullDay: true,
    });

  if (Number.isFinite(rowWorkerId)) {
    const match = assignments.find((entry) => {
      const id = Number(entry?.worker?.id ?? entry?.worker_id);
      return Number.isFinite(id) && id === rowWorkerId;
    });
    const seconds = withTimes(match);
    if (seconds > 0) return seconds;
  }

  if (assignments.length === 1) {
    const seconds = withTimes(assignments[0]);
    if (seconds > 0) return seconds;
  }

  return 0;
};

/** V5 billing splits overlap by participant — use that row's slot, not the sum. */
const computeAdvanceCalendarSlotSeconds = (shift) => {
  const splitShifts = shift.split_shifts || shift.splitShifts || [];
  const participantId = shift.calendar_row_participant_id ?? null;

  if (Array.isArray(splitShifts) && splitShifts.length > 0 && participantId) {
    const participantSplits = splitShifts.filter((split) =>
      splitBelongsToParticipant(split, participantId)
    );
    if (participantSplits.length > 0) {
      const slotSeconds = participantSplits.reduce((total, split) => {
        const segmentSeconds = secondsFromDurationOrRange(
          split.duration,
          split.start_time,
          split.end_time,
          { sameClockFullDay: true }
        );
        return total + segmentSeconds;
      }, 0);
      if (slotSeconds > 0) {
        return applySleepoverToSeconds(slotSeconds, shift.sleepover);
      }
    }
  }

  const assignmentSeconds = getAdvanceWorkerAssignmentSeconds(shift);
  if (assignmentSeconds > 0) {
    return applySleepoverToSeconds(assignmentSeconds, shift.sleepover);
  }

  return fallbackShiftWindowSeconds(shift);
};

export const computeWorkerScheduleShiftSeconds = (shift) => {
  if (!shift) return 0;

  if (parseBooleanVal(shift.is_multi_assignment)) {
    return computeAdvanceCalendarSlotSeconds(shift);
  }

  const splitShifts = shift.split_shifts || shift.splitShifts;
  if (parseBooleanVal(shift.is_split_shift)) {
    if (!splitShifts?.length) {
      return 0;
    }
    return sumNonSleepoverSplitSeconds(splitShifts);
  }

  return fallbackShiftWindowSeconds(shift);
};

export const computeWorkerSleepoverCount = (shift) => {
  if (!shift) return 0;

  if (parseBooleanVal(shift.is_multi_assignment)) {
    const assignments = getAdvanceCalendarWorkerAssignments(shift);
    const rowWorkerId = Number(
      shift?.calendar_row_worker_id ?? shift?.worker_id ?? shift?.worker?.id
    );
    if (Number.isFinite(rowWorkerId) && assignments.length > 0) {
      const match = assignments.find((entry) => {
        const id = Number(entry?.worker?.id ?? entry?.worker_id);
        return Number.isFinite(id) && id === rowWorkerId;
      });
      if (match) {
        return isTruthySleepoverFlag(
          match.sleepover ?? match.is_sleepover ?? shift.sleepover
        )
          ? 1
          : 0;
      }
    }
    return isTruthySleepoverFlag(shift?.sleepover) ? 1 : 0;
  }

  const splitShifts = shift?.split_shifts || shift?.splitShifts;
  if (parseBooleanVal(shift?.is_split_shift) && splitShifts?.length > 0) {
    return splitShifts.filter((split) =>
      isTruthySleepoverFlag(split.is_sleepover ?? split.sleepover)
    ).length;
  }
  return isTruthySleepoverFlag(shift?.sleepover) ? 1 : 0;
};

export const enrichShiftScheduleTotals = (shift) => {
  if (!shift) return shift;

  const splitShifts = shift.split_shifts || shift.splitShifts;
  const normalized = {
    ...shift,
    is_split_shift: parseBooleanVal(shift.is_split_shift),
    ...(splitShifts ? { split_shifts: splitShifts, splitShifts } : {}),
  };

  return {
    ...normalized,
    worker_schedule_seconds: computeWorkerScheduleShiftSeconds(normalized),
    worker_sleepover_count: computeWorkerSleepoverCount(normalized),
  };
};

/** Clone + total a V5 shift for one worker or participant calendar row. */
export const enrichShiftScheduleTotalsForCalendarRow = (
  shift,
  targetKey,
  targetId
) => {
  if (!shift) return shift;
  if (!parseBooleanVal(shift.is_multi_assignment)) {
    return enrichShiftScheduleTotals(shift);
  }

  const rowShift = { ...shift };
  if (targetKey === "worker" && targetId != null) {
    rowShift.calendar_row_worker_id = targetId;
    const assignment = getAdvanceCalendarWorkerAssignments(shift).find(
      (entry) => {
        const id = Number(entry?.worker?.id ?? entry?.worker_id);
        return Number.isFinite(id) && id === Number(targetId);
      }
    );
    if (assignment?.start_time && assignment?.end_time) {
      rowShift.start_time = assignment.start_time;
      rowShift.end_time = assignment.end_time;
      if (assignment.sleepover != null || assignment.is_sleepover != null) {
        rowShift.sleepover = Boolean(
          assignment.sleepover ?? assignment.is_sleepover
        );
      }
    }
  }
  if (targetKey === "participant" && targetId != null) {
    rowShift.calendar_row_participant_id = targetId;
    rowShift.pt_id = targetId;
  }

  return enrichShiftScheduleTotals(rowShift);
};

export const getWorkerScheduleShiftSeconds = (shift) => {
  if (!shift) return 0;

  if (isAdvanceCalendarShift(shift)) {
    return computeWorkerScheduleShiftSeconds(shift);
  }

  const stored = Number(shift.worker_schedule_seconds);
  if (
    shift.worker_schedule_seconds !== undefined &&
    shift.worker_schedule_seconds !== null &&
    Number.isFinite(stored) &&
    stored > 0
  ) {
    return stored;
  }

  return computeWorkerScheduleShiftSeconds(shift);
};

export const sumUniqueWorkerScheduleShiftSeconds = (shifts = []) => {
  const seen = new Set();
  return (shifts || []).reduce((sum, shift) => {
    const key = shift?.uuid ?? shift?.id;
    if (key != null) {
      if (seen.has(key)) return sum;
      seen.add(key);
    }
    return sum + getWorkerScheduleShiftSeconds(shift);
  }, 0);
};

export const countWorkerSleepoverShifts = (shifts = []) => {
  const seen = new Set();
  return (shifts || []).reduce((count, shift) => {
    const key = shift?.uuid ?? shift?.id;
    if (key != null) {
      if (seen.has(key)) return count;
      seen.add(key);
    }
    if (parseBooleanVal(shift?.is_multi_assignment)) {
      return count + computeWorkerSleepoverCount(shift);
    }
    if (
      shift?.worker_sleepover_count !== undefined &&
      shift?.worker_sleepover_count !== null
    ) {
      return count + (Number(shift.worker_sleepover_count) || 0);
    }

    return count + computeWorkerSleepoverCount(shift);
  }, 0);
};

